import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { dossiersAPI, gestionnairesAPI, tablesAPI, agircAPI, configAPI, documentsAPI, checklistAPI, detailDossierConfigAPI, clientFormAPI, clientLinkConfigAPI, clientDocumentsAPI, dossierConfigAPI, travauxAPI, installateursAPI, aideStatutsAPI, categoriesRemarquesAPI, actionsRapidesAPI, statutsProgressionAPI, amoAPI } from '../services/api';
import { suiviAPI } from '../services/suiviAPI';
import AgentIAChat from '../components/AgentIAChat';
import DynamicDossierView from '../components/DynamicDossierView';
import DynamicSuiviView from '../components/DynamicSuiviView';
import DossierMessaging from '../components/DossierMessaging';
import ParcoursProgress from '../components/ParcoursProgress';
import { 
  WidgetChecklist, 
  WidgetCompletude, 
  WidgetHistorique, 
  WidgetAlertes, 
  WidgetFormulaires 
} from '../components/widgets';
import { 
  ArrowLeft, Download, Edit, Save, X, MessageSquare, 
  FileText, Activity, MessageCircle, Phone, Mail, Globe, Clock,
  Send, Trash2, User, Home, Wallet, CreditCard, Loader2, AlertTriangle,
  Upload, File, Eye, FolderOpen, Edit3, Check, Link, Copy, ExternalLink, Hammer, CheckCircle, Building2, Calendar, Euro, ClipboardList, MapPin, Accessibility, ChevronDown
} from 'lucide-react';

const DossierDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('dossier');
  const [dossier, setDossier] = useState(null);
  const [organisme, setOrganisme] = useState(null);
  const [suivis, setSuivis] = useState([]);
  const [remarques, setRemarques] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [showAI, setShowAI] = useState(false);
  const [gestionnaires, setGestionnaires] = useState([]);
  const [editData, setEditData] = useState({});
  const [newRemarque, setNewRemarque] = useState('');
  const [newRemarqueCategorie, setNewRemarqueCategorie] = useState('info');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFullData, setEditFullData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [searchingCaisse, setSearchingCaisse] = useState(false);
  const [caisseNotification, setCaisseNotification] = useState(null);
  const [caisses, setCaisses] = useState([]);
  const [statuts, setStatuts] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [uploadingDoc, setUploadingDoc] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState('');
  const [deletingDocId, setDeletingDocId] = useState(null);
  const [testCaisseStatus, setTestCaisseStatus] = useState(null);
  const [testCaisseResult, setTestCaisseResult] = useState(null);
  const [widgetRefresh, setWidgetRefresh] = useState(0);
  
  // États pour l'édition inline dans "Détail du dossier"
  const [detailConfig, setDetailConfig] = useState([]);
  const [editingField, setEditingField] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const [savingField, setSavingField] = useState(false);
  
  // État pour le lien client
  const [clientLink, setClientLink] = useState(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const [showClientLinkModal, setShowClientLinkModal] = useState(false);
  const [clientLinkConfig, setClientLinkConfig] = useState({ enabled: true });
  const [generatingLink, setGeneratingLink] = useState(false);
  
  // État pour le lien documents
  const [documentsLink, setDocumentsLink] = useState(null);
  const [showDocumentsLinkModal, setShowDocumentsLinkModal] = useState(false);
  const [generatingDocumentsLink, setGeneratingDocumentsLink] = useState(false);
  const [copyDocumentsSuccess, setCopyDocumentsSuccess] = useState(false);
  
  // État pour les actions rapides
  const [showQuickActionModal, setShowQuickActionModal] = useState(false);
  const [quickActionType, setQuickActionType] = useState(null);
  const [quickActionNote, setQuickActionNote] = useState('');
  const [quickActionDate, setQuickActionDate] = useState('');
  const [savingQuickAction, setSavingQuickAction] = useState(false);
  
  // État pour les infos du département
  const [departementInfo, setDepartementInfo] = useState(null);
  
  // État pour les demandes d'aide (pipelines)
  const [aideCaisse, setAideCaisse] = useState(false);
  const [aideDepartement, setAideDepartement] = useState(false);
  const [aideCaisseStatut, setAideCaisseStatut] = useState('non_demande');
  const [aideDepartementStatut, setAideDepartementStatut] = useState('non_demande');
  
  // État pour la configuration de l'onglet Documents
  const [documentsPageConfig, setDocumentsPageConfig] = useState({
    widget_completude: true,
    widget_alertes: true,
    widget_checklist: true,
    widget_formulaires: true,
    widget_documents_uploades: true
  });
  
  // Statuts possibles pour les demandes d'aide (chargés depuis la BDD)
  const [aideStatuts, setAideStatuts] = useState([]);
  const [categoriesRemarques, setCategoriesRemarques] = useState({});
  const [quickActionTypes, setQuickActionTypes] = useState({});
  const [statutsProgression, setStatutsProgression] = useState([]);

  // État pour l'onglet Installateur
  const [travauxTypes, setTravauxTypes] = useState([]);
  const [installateursList, setInstallateursList] = useState([]);
  const [installateurData, setInstallateurData] = useState({
    nom_installateur: '',
    installateur_id: null, // ID de l'installateur sélectionné
    montant_devis: '',
    montant_anah: '',
    montant_paye_client: '', // Montant déjà payé par le client
    travaux_selectionnes: [],
    statut_travaux: '' // 'non_demarre', 'en_cours', 'termines'
  });
  const [saisieManuelle, setSaisieManuelle] = useState(false);
  const [showInstallateursList, setShowInstallateursList] = useState(true);
  const [savingInstallateur, setSavingInstallateur] = useState(false);

  // État pour l'onglet AMO
  const [amoList, setAmoList] = useState([]);
  const [amoData, setAmoData] = useState({
    amo_id: null,
    amo_nom: '',
    anah_demande_faite: false,
    anah_date_demande: '',
    anah_reponse_recue: false,
    anah_date_reponse: '',
    anah_statut: '', // 'valide', 'refuse', 'en_attente'
    anah_budget_accorde: ''
  });
  const [savingAmo, setSavingAmo] = useState(false);

  // État pour le parcours organisme
  const [etapeParcoursActuelle, setEtapeParcoursActuelle] = useState(null);

  // État pour le handicap
  const [handicapExpanded, setHandicapExpanded] = useState(false);
  const [savingHandicap, setSavingHandicap] = useState(false);

  const triggerWidgetRefresh = () => {
    setWidgetRefresh(prev => prev + 1);
  };

  // Charger les configurations depuis la BDD
  const loadConfigData = async () => {
    try {
      const [aideRes, catRes, actionsRes, progressRes] = await Promise.all([
        aideStatutsAPI.getAll(),
        categoriesRemarquesAPI.getAll(),
        actionsRapidesAPI.getAll(),
        statutsProgressionAPI.getAll()
      ]);
      
      setAideStatuts(aideRes.data || []);
      
      // Transformer les catégories en objet
      const catObj = {};
      (catRes.data || []).forEach(cat => {
        catObj[cat.code] = { label: cat.label, icon: cat.icone, color: cat.couleur };
      });
      setCategoriesRemarques(catObj);
      
      // Transformer les actions en objet
      const actObj = {};
      (actionsRes.data || []).forEach(act => {
        actObj[act.code] = { label: act.label, icon: act.icone, color: act.couleur, description: act.description };
      });
      setQuickActionTypes(actObj);
      
      setStatutsProgression(progressRes.data || []);
    } catch (error) {
      console.error('Erreur chargement config:', error);
      // Fallback aux valeurs par défaut si erreur
      setAideStatuts([
        { code: 'non_demande', label: 'Non demandé', progress: 0 },
        { code: 'a_contacter', label: 'À contacter', progress: 20 },
        { code: 'en_attente', label: 'En attente', progress: 40 },
        { code: 'dossier_envoye', label: 'Dossier envoyé', progress: 60 },
        { code: 'en_cours', label: 'En cours', progress: 80 },
        { code: 'accepte', label: 'Accepté', progress: 100 },
        { code: 'refuse', label: 'Refusé', progress: 100 }
      ]);
      setCategoriesRemarques({
        info: { label: 'Information', icon: 'ℹ️', color: 'bg-blue-100 text-blue-800 border-blue-200' },
        probleme: { label: 'Problème', icon: '⚠️', color: 'bg-red-100 text-red-800 border-red-200' },
        action: { label: 'Action faite', icon: '✅', color: 'bg-green-100 text-green-800 border-green-200' },
        a_faire: { label: 'À faire', icon: '📌', color: 'bg-orange-100 text-orange-800 border-orange-200' }
      });
      setQuickActionTypes({
        appel: { label: 'Appel passé', icon: '📞', color: 'bg-blue-600', description: 'J\'ai appelé...' },
        email: { label: 'Email envoyé', icon: '📧', color: 'bg-purple-600', description: 'J\'ai envoyé un email à...' },
        courrier: { label: 'Courrier envoyé', icon: '📮', color: 'bg-amber-600', description: 'J\'ai envoyé un courrier à...' },
        rdv: { label: 'RDV pris', icon: '📅', color: 'bg-green-600', description: 'RDV planifié avec...' }
      });
      setStatutsProgression([
        { code: 'new', label: 'Nouveau', progress: 0, couleur: 'bg-gray-400' },
        { code: 'inprog', label: 'En cours', progress: 20, couleur: 'bg-blue-500' },
        { code: 'pending_docs', label: 'Attente docs', progress: 40, couleur: 'bg-orange-500' },
        { code: 'sent_caisse', label: 'Envoyé caisse', progress: 60, couleur: 'bg-purple-500' },
        { code: 'done', label: 'Clôturé', progress: 80, couleur: 'bg-green-500' },
        { code: 'paid', label: 'Payé', progress: 100, couleur: 'bg-green-600' }
      ]);
    }
  };

  useEffect(() => {
    loadData();
    loadDetailConfig();
    loadClientLinkConfig();
    loadDocumentsPageConfig();
    loadTravauxTypes();
    loadInstallateursList();
    loadAmoList();
    loadConfigData();
  }, [id]);

  const loadTravauxTypes = async () => {
    try {
      const res = await travauxAPI.getTypes();
      setTravauxTypes(res.data || []);
    } catch (error) {
      console.error('Erreur chargement types travaux:', error);
    }
  };

  const loadInstallateursList = async () => {
    try {
      const res = await installateursAPI.getAll();
      setInstallateursList(res.data || []);
    } catch (error) {
      console.error('Erreur chargement installateurs:', error);
    }
  };

  const loadAmoList = async () => {
    try {
      const res = await amoAPI.getAll();
      setAmoList(res.data || []);
    } catch (error) {
      console.error('Erreur chargement AMO:', error);
    }
  };
  
  const loadDocumentsPageConfig = async () => {
    try {
      const res = await dossierConfigAPI.getDocumentsPageConfig();
      if (res.data.widgets) {
        setDocumentsPageConfig(res.data.widgets);
      }
    } catch (error) {
      console.error('Erreur chargement config documents:', error);
    }
  };

  const loadClientLinkConfig = async () => {
    try {
      const res = await clientLinkConfigAPI.getConfig();
      setClientLinkConfig(res.data);
    } catch (error) {
      console.error('Erreur chargement config lien client:', error);
    }
  };

  const loadDetailConfig = async () => {
    try {
      const res = await detailDossierConfigAPI.getElements();
      setDetailConfig(res.data.elements.filter(e => e.visible).sort((a, b) => a.ordre - b.ordre));
    } catch (error) {
      console.error('Erreur chargement config détail:', error);
    }
  };

  const loadData = async () => {
    try {
      const [dossierRes, gestRes, statutsRes] = await Promise.all([
        dossiersAPI.getById(id),
        gestionnairesAPI.getAll(),
        configAPI.getStatuts()
      ]);
      setDossier(dossierRes.data);
      setGestionnaires(gestRes.data);
      setStatuts(statutsRes.data);
      setEditData({
        statut: dossierRes.data.statut,
        priorite: dossierRes.data.priorite,
        gestionnaire_id: dossierRes.data.gestionnaire_id || '',
        note_interne: dossierRes.data.note_interne || ''
      });
      
      // Charger les données installateur
      setInstallateurData({
        nom_installateur: dossierRes.data.nom_installateur || '',
        installateur_id: dossierRes.data.installateur_id || null,
        montant_devis: dossierRes.data.montant_devis || '',
        montant_anah: dossierRes.data.montant_anah || '',
        montant_paye_client: dossierRes.data.montant_paye_client || '',
        travaux_selectionnes: dossierRes.data.travaux_selectionnes || [],
        statut_travaux: dossierRes.data.statut_travaux || ''
      });
      
      // Déterminer si c'est une saisie manuelle ou si un installateur est déjà sélectionné
      if (dossierRes.data.nom_installateur && !dossierRes.data.installateur_id) {
        setSaisieManuelle(true);
        setShowInstallateursList(false);
      } else if (dossierRes.data.installateur_id) {
        setShowInstallateursList(false);
      }
      
      // Charger les données AMO
      setAmoData({
        amo_id: dossierRes.data.amo_id || null,
        amo_nom: dossierRes.data.amo_nom || '',
        anah_demande_faite: dossierRes.data.anah_demande_faite || false,
        anah_date_demande: dossierRes.data.anah_date_demande || '',
        anah_reponse_recue: dossierRes.data.anah_reponse_recue || false,
        anah_date_reponse: dossierRes.data.anah_date_reponse || '',
        anah_statut: dossierRes.data.anah_statut || '',
        anah_budget_accorde: dossierRes.data.anah_budget_accorde || ''
      });
      
      // Marquer le dossier comme vu si nouveau et non vu
      if (dossierRes.data.statut === 'new' && dossierRes.data.is_viewed !== true) {
        try {
          const markRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/dossiers/${id}/mark-viewed`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          if (markRes.ok) {
            console.log('Dossier marqué comme vu');
            // Signaler à la liste qu'elle doit se rafraîchir
            sessionStorage.setItem('dossiers_list_needs_refresh', 'true');
          }
        } catch (e) {
          console.error('Erreur marquage vu:', e);
        }
      }

      // Charger l'organisme (caisse)
      const caissesRes = await tablesAPI.getCaisses();
      setCaisses(caissesRes.data);
      const orgFound = caissesRes.data.find(c => c.nom === dossierRes.data.caisse);
      setOrganisme(orgFound);
      
      // Charger les infos du département basé sur le code postal
      const codePostal = dossierRes.data.identite?.code_postal || '';
      if (codePostal && codePostal.length >= 2) {
        const deptCode = codePostal.substring(0, 2);
        try {
          const deptRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tables/departements?code=${deptCode}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          const deptData = await deptRes.json();
          if (deptData && deptData.length > 0) {
            const deptFound = deptData[0];
            setDepartementInfo({
              ...deptFound,
              fullName: `Conseil départemental ${deptCode} - ${deptFound.nom}`
            });
          }
        } catch (error) {
          console.error('Erreur chargement département:', error);
        }
      }

      // Charger suivis et commentaires
      const [suivisRes, commentsRes, docsRes, docTypesRes] = await Promise.all([
        suiviAPI.getSuivis(id),
        suiviAPI.getCommentaires(id),
        documentsAPI.getByDossier(id),
        documentsAPI.getTypes()
      ]);
      setSuivis(suivisRes.data);
      setRemarques(commentsRes.data);
      setDocuments(docsRes.data);
      setDocumentTypes(docTypesRes.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const oldStatut = dossier.statut;
      await dossiersAPI.update(id, editData);
      
      // Créer un suivi si le statut a changé
      if (editData.statut !== oldStatut) {
        await suiviAPI.createSuivi({
          dossier_id: id,
          type_action: 'modification_statut',
          description: `Statut changé: ${oldStatut} → ${editData.statut}`,
          user_id: user.id,
          user_nom: `${user.prenom} ${user.nom}`
        });
      }
      
      await loadData();
      setEditing(false);
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la sauvegarde');
    }
  };

  // Sauvegarder les données installateur
  const saveInstallateurData = async () => {
    setSavingInstallateur(true);
    try {
      await dossiersAPI.update(id, {
        nom_installateur: installateurData.nom_installateur,
        installateur_id: installateurData.installateur_id,
        montant_devis: installateurData.montant_devis ? parseFloat(installateurData.montant_devis) : null,
        montant_anah: installateurData.montant_anah ? parseFloat(installateurData.montant_anah) : null,
        montant_paye_client: installateurData.montant_paye_client ? parseFloat(installateurData.montant_paye_client) : null,
        travaux_selectionnes: installateurData.travaux_selectionnes,
        statut_travaux: installateurData.statut_travaux
      });
      
      // Créer un suivi
      await suiviAPI.createSuivi({
        dossier_id: id,
        type_action: 'modification_installateur',
        description: `Données installateur mises à jour`,
        user_id: user.id,
        user_nom: `${user.prenom} ${user.nom}`
      });
      
      await loadData();
    } catch (error) {
      console.error('Erreur sauvegarde installateur:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSavingInstallateur(false);
    }
  };

  // Sélectionner un installateur pré-enregistré
  const selectInstallateur = (inst) => {
    if (installateurData.installateur_id === inst.id) {
      // Désélectionner
      setInstallateurData(prev => ({
        ...prev,
        installateur_id: null,
        nom_installateur: ''
      }));
      setShowInstallateursList(true);
    } else {
      // Sélectionner et masquer la liste
      setInstallateurData(prev => ({
        ...prev,
        installateur_id: inst.id,
        nom_installateur: inst.nom
      }));
      setSaisieManuelle(false);
      setShowInstallateursList(false);
    }
  };

  // Basculer en saisie manuelle
  const toggleSaisieManuelle = () => {
    setSaisieManuelle(!saisieManuelle);
    if (!saisieManuelle) {
      // Passer en saisie manuelle : effacer l'installateur sélectionné
      setInstallateurData(prev => ({
        ...prev,
        installateur_id: null,
        nom_installateur: ''
      }));
      setShowInstallateursList(false);
    } else {
      // Revenir à la liste
      setShowInstallateursList(true);
    }
  };
  
  // Changer d'installateur (revenir à la liste)
  const changeInstallateur = () => {
    setInstallateurData(prev => ({
      ...prev,
      installateur_id: null,
      nom_installateur: ''
    }));
    setShowInstallateursList(true);
    setSaisieManuelle(false);
  };

  const toggleTravauxSelection = (code) => {
    setInstallateurData(prev => ({
      ...prev,
      travaux_selectionnes: prev.travaux_selectionnes.includes(code)
        ? prev.travaux_selectionnes.filter(c => c !== code)
        : [...prev.travaux_selectionnes, code]
    }));
  };

  // Fonctions d'édition inline pour "Détail du dossier"
  const startEditingField = (field, currentValue) => {
    setEditingField(field);
    setEditingValue(currentValue || '');
  };

  const cancelEditingField = () => {
    setEditingField(null);
    setEditingValue('');
  };

  const saveFieldEdit = async () => {
    if (!editingField) return;
    setSavingField(true);
    
    try {
      const updateData = {};
      
      if (editingField === 'gestionnaire') {
        updateData.gestionnaire_id = editingValue || null;
        // Trouver le nom du gestionnaire
        const gest = gestionnaires.find(g => g.id === editingValue);
        updateData.gestionnaire_nom = gest ? `${gest.prenom} ${gest.nom}` : null;
      } else if (editingField === 'statut') {
        updateData.statut = editingValue;
        // Créer un suivi
        await suiviAPI.createSuivi({
          dossier_id: id,
          type_action: 'modification_statut',
          description: `Statut changé: ${dossier.statut} → ${editingValue}`,
          user_id: user.id,
          user_nom: `${user.prenom} ${user.nom}`
        });
      } else if (editingField === 'priorite') {
        updateData.priorite = editingValue || null;
      } else if (editingField === 'source') {
        updateData.source = editingValue;
      } else if (editingField === 'note_interne') {
        updateData.note_interne = editingValue || null;
      }
      
      await dossiersAPI.update(id, updateData);
      await loadData();
      setEditingField(null);
      setEditingValue('');
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSavingField(false);
    }
  };

  const isElementVisible = (code) => {
    const el = detailConfig.find(e => e.code === code);
    return el ? el.visible : true;
  };

  // Fonction pour générer et copier le lien client
  const handleGenerateClientLink = async () => {
    setGeneratingLink(true);
    try {
      const res = await clientFormAPI.generateToken(id);
      const fullUrl = `${window.location.origin}/client/${res.data.token}`;
      setClientLink(fullUrl);
      setShowClientLinkModal(true);
    } catch (error) {
      console.error('Erreur génération lien:', error);
      alert('Erreur lors de la génération du lien');
    } finally {
      setGeneratingLink(false);
    }
  };

  const handleCopyClientLink = async () => {
    if (!clientLink) return;
    try {
      await navigator.clipboard.writeText(clientLink);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 3000);
    } catch (error) {
      console.error('Erreur copie:', error);
      // Fallback pour les navigateurs qui ne supportent pas clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = clientLink;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 3000);
    }
  };

  // Fonction pour générer le lien documents
  const handleGenerateDocumentsLink = async () => {
    setGeneratingDocumentsLink(true);
    try {
      const res = await clientDocumentsAPI.generateToken(id);
      const fullUrl = `${window.location.origin}/documents/${res.data.token}`;
      setDocumentsLink(fullUrl);
      setShowDocumentsLinkModal(true);
    } catch (error) {
      console.error('Erreur génération lien documents:', error);
      alert('Erreur lors de la génération du lien');
    } finally {
      setGeneratingDocumentsLink(false);
    }
  };

  const handleCopyDocumentsLink = async () => {
    if (!documentsLink) return;
    try {
      await navigator.clipboard.writeText(documentsLink);
      setCopyDocumentsSuccess(true);
      setTimeout(() => setCopyDocumentsSuccess(false), 3000);
    } catch (error) {
      const textArea = document.createElement('textarea');
      textArea.value = documentsLink;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopyDocumentsSuccess(true);
      setTimeout(() => setCopyDocumentsSuccess(false), 3000);
    }
  };

  const openEditModal = () => {
    setEditFullData({
      identite: { ...dossier.identite },
      situation: { ...dossier.situation },
      ressources: { ...dossier.ressources },
      charges: { ...dossier.charges },
      caisse: dossier.caisse,
      motif: dossier.motif,
      statut: dossier.statut,
      priorite: dossier.priorite,
      gestionnaire_id: dossier.gestionnaire_id || '',
      source: dossier.source,
      note_interne: dossier.note_interne || ''
    });
    setTestCaisseStatus(null);
    setTestCaisseResult(null);
    setShowEditModal(true);
  };

  const handleFullSave = async () => {
    setSaving(true);
    try {
      await dossiersAPI.update(id, editFullData);
      
      // Créer un suivi
      await suiviAPI.createSuivi({
        dossier_id: id,
        type_action: 'modification',
        description: 'Fiche client modifiée',
        user_id: user.id,
        user_nom: `${user.prenom} ${user.nom}`
      });
      
      await loadData();
      setShowEditModal(false);
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const updateEditField = (section, field, value) => {
    if (section) {
      setEditFullData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value
        }
      }));
    } else {
      setEditFullData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  // Recherche automatique AGIRC-ARRCO dans la modal
  const rechercherCaisseAgirc = useCallback(async () => {
    if (!editFullData) return;
    
    const { nom, prenom, nss, cle_nss } = editFullData.identite;
    
    if (!nom || !prenom || !nss || nss.length !== 13 || !cle_nss || cle_nss.length !== 2) {
      return;
    }
    
    setSearchingCaisse(true);
    setCaisseNotification(null);
    
    try {
      const res = await agircAPI.rechercheCaisse({
        nom,
        prenom,
        nss,
        cle_nss
      });
      
      if (res.data.success) {
        setEditFullData(prev => ({ ...prev, caisse: res.data.caisse }));
        
        if (res.data.is_new_caisse) {
          const caissesRes = await tablesAPI.getCaisses();
          setCaisses(caissesRes.data);
          setCaisseNotification({
            type: 'new',
            message: `Nouvelle caisse ajoutée : ${res.data.caisse}. Pensez à compléter ses coordonnées.`
          });
        } else {
          setCaisseNotification({
            type: 'found',
            message: `Caisse trouvée : ${res.data.caisse}`
          });
        }
      }
    } catch (error) {
      console.error('Erreur recherche AGIRC:', error);
    } finally {
      setSearchingCaisse(false);
    }
  }, [editFullData?.identite?.nom, editFullData?.identite?.prenom, editFullData?.identite?.nss, editFullData?.identite?.cle_nss]);

  const handleAddRemarque = async () => {
    if (!newRemarque.trim()) return;
    
    try {
      await suiviAPI.createCommentaire({
        dossier_id: id,
        message: newRemarque,
        categorie: newRemarqueCategorie,
        user_id: user.id,
        user_nom: `${user.prenom} ${user.nom}`,
        user_avatar_color: user.avatar_color
      });
      
      setNewRemarque('');
      setNewRemarqueCategorie('info');
      await loadData();
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'ajout de la remarque');
    }
  };

  const handleDeleteRemarque = async (remarqueId) => {
    if (!window.confirm('Supprimer cette remarque ?')) return;
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/suivi/commentaires/${remarqueId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erreur serveur');
      }
      
      // Mettre à jour localement - suppression instantanée
      setRemarques(prev => prev.filter(r => r.id !== remarqueId));
    } catch (error) {
      console.error('Erreur suppression:', error);
      alert('Erreur lors de la suppression: ' + error.message);
    }
  };

  const openQuickAction = (type) => {
    setQuickActionType(type);
    setQuickActionNote('');
    setQuickActionDate(new Date().toISOString().slice(0, 16)); // Format datetime-local
    setShowQuickActionModal(true);
  };

  const handleSaveQuickAction = async () => {
    if (!quickActionNote.trim()) return;
    
    setSavingQuickAction(true);
    try {
      const actionInfo = quickActionTypes[quickActionType];
      const actionDescription = `${actionInfo.icon} ${actionInfo.label} : ${quickActionNote}`;
      
      // Enregistrer dans le suivi
      await suiviAPI.createSuivi({
        dossier_id: id,
        type_action: quickActionType,
        description: actionDescription,
        user_id: user.id,
        user_nom: `${user.prenom} ${user.nom}`
      });
      
      // Ajouter aussi dans les remarques pour l'historique
      await suiviAPI.createCommentaire({
        dossier_id: id,
        message: actionDescription,
        categorie: 'action',
        user_id: user.id,
        user_nom: `${user.prenom} ${user.nom}`,
        user_avatar_color: user.avatar_color
      });
      
      setShowQuickActionModal(false);
      setQuickActionNote('');
      await loadData();
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'enregistrement');
    } finally {
      setSavingQuickAction(false);
    }
  };

  const handleExportPDF = async () => {
    try {
      const { aiAPI } = await import('../services/api');
      const response = await aiAPI.exportPDF(id);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${dossier.reference}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Erreur export PDF:', error);
      alert('Erreur lors de l\'export PDF');
    }
  };

  const getStatusBadge = (statutCode) => {
    const statutConfig = statuts.find(s => s.code === statutCode);
    if (statutConfig) {
      return {
        label: statutConfig.label,
        class: `text-white`,
        style: { backgroundColor: statutConfig.couleur },
        icone: statutConfig.icone
      };
    }
    // Fallback pour les anciens statuts
    const fallback = {
      new: { label: 'Nouveau', class: 'bg-blue-100 text-blue-700' },
      inprog: { label: 'En cours', class: 'bg-yellow-100 text-yellow-700' },
      done: { label: 'Clôturé', class: 'bg-green-100 text-green-700' },
      reject: { label: 'Refusé', class: 'bg-red-100 text-red-700' }
    };
    return fallback[statutCode] || fallback.new;
  };

  const calculateFinances = () => {
    if (!dossier) return { ressources: 0, charges: 0, reste: 0 };
    const r = dossier.ressources;
    const c = dossier.charges;
    const ressources = (r.retraite_base || 0) + (r.retraite_complementaire || 0) + (r.autres_revenus || 0);
    const charges = (c.loyer || 0) + (c.copropriete || 0) + (c.taxe_fonciere || 0) + (c.impot_revenu || 0) +
      (c.assurance_habitation || 0) + (c.assurance_vehicule || 0) + (c.assurance_autre || 0) +
      (c.energie || 0) + (c.telephonie || 0) + (c.eau || 0) + (c.autres_charges || 0);
    return { ressources, charges, reste: ressources - charges };
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (!dossier) {
    return (
      <div className="text-center py-20">
        <p className="text-xl text-gray-600">Dossier non trouvé</p>
      </div>
    );
  }

  const statusBadge = getStatusBadge(dossier.statut);
  const finances = calculateFinances();

  return (
    <div className="space-y-4">
      {/* Header - Compact */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/dossiers')}
            className="p-1.5 hover:bg-gray-100 rounded-lg transition"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h1 className="text-xl font-bold text-gray-900">{dossier.reference}</h1>
            <p className="text-gray-600 text-sm">
              {dossier.identite.prenom} {dossier.identite.nom}
            </p>
          </div>
        </div>

        <div className="flex gap-2">
          {editing ? (
            <>
              <button
                onClick={handleSave}
                className="bg-green-600 text-white px-3 py-1.5 rounded-lg font-medium hover:bg-green-700 transition flex items-center gap-1.5 text-sm"
              >
                <Save className="w-4 h-4" />
                Sauvegarder
              </button>
              <button
                onClick={() => setEditing(false)}
                className="bg-gray-600 text-white px-3 py-1.5 rounded-lg font-medium hover:bg-gray-700 transition flex items-center gap-1.5 text-sm"
              >
                <X className="w-4 h-4" />
                Annuler
              </button>
            </>
          ) : (
            <>
              <button
                onClick={openEditModal}
                className="bg-green-600 text-white px-3 py-2 rounded-lg font-medium hover:bg-green-700 transition flex items-center gap-2 text-sm"
                data-testid="edit-dossier-btn"
              >
                <Edit className="w-4 h-4" />
                Modifier
              </button>
              {clientLinkConfig.enabled && (
                <button
                  onClick={handleGenerateClientLink}
                  disabled={generatingLink}
                  className="px-3 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition flex items-center gap-2 disabled:opacity-50 text-sm"
                  data-testid="copy-client-link-btn"
                  title="Générer un lien pour le client"
                >
                  {generatingLink ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <>
                      <Link className="w-4 h-4" />
                      Lien client
                    </>
                  )}
                </button>
              )}
              <button
                onClick={handleGenerateDocumentsLink}
                disabled={generatingDocumentsLink}
                className="px-3 py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition flex items-center gap-2 disabled:opacity-50 text-sm"
                data-testid="copy-documents-link-btn"
                title="Générer un lien pour les documents"
              >
                {generatingDocumentsLink ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <>
                    <Upload className="w-4 h-4" />
                    Lien docs
                  </>
                )}
              </button>
            </>
          )}
        </div>
      </div>

      {/* Barre d'actions rapides */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-2">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs font-medium text-gray-500">Actions :</span>
          
          {/* Changement de statut */}
          <div className="flex items-center gap-1">
            <select
              value={dossier?.statut || ''}
              onChange={async (e) => {
                try {
                  await dossiersAPI.update(id, { statut: e.target.value });
                  await loadData();
                } catch (error) {
                  console.error('Erreur changement statut:', error);
                }
              }}
              className="px-2 py-1 border border-gray-200 rounded text-xs bg-white hover:border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent transition cursor-pointer"
            >
              {statutsProgression.map(s => (
                <option key={s.code} value={s.code}>{s.label}</option>
              ))}
            </select>
          </div>

          <div className="w-px h-5 bg-gray-200"></div>

          {Object.entries(quickActionTypes).map(([key, action]) => {
            const hoverColors = {
              'bg-blue-600': 'hover:bg-blue-600',
              'bg-purple-600': 'hover:bg-purple-600',
              'bg-amber-600': 'hover:bg-amber-600',
              'bg-green-600': 'hover:bg-green-600'
            };
            return (
              <button
                key={key}
                onClick={() => openQuickAction(key)}
                className={`bg-white border border-gray-200 text-gray-600 px-2 py-1 rounded font-medium ${hoverColors[action.color]} hover:text-white hover:border-transparent transition flex items-center gap-1 text-xs`}
              >
                <span>{action.icon}</span>
                {action.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Barre de progression du dossier */}
      {(() => {
        // Utiliser les statuts chargés depuis la BDD
        const progressionStatuts = statutsProgression.filter(s => s.code !== 'refuse');
        
        const isRefused = dossier?.statut === 'refuse';
        const currentStatut = statutsProgression.find(s => s.code === dossier?.statut) || 
                             (isRefused ? { code: 'refuse', label: 'Refusé', progress: 100, couleur: 'bg-red-500' } : progressionStatuts[0]);
        const currentIndex = progressionStatuts.findIndex(s => s.code === dossier?.statut);
        
        return (
          <div className={`bg-white rounded-lg shadow-sm border ${isRefused ? 'border-red-300' : 'border-gray-200'} px-4 py-3`}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-medium text-gray-500">Progression du dossier</span>
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                currentStatut.code === 'paiement_effectue' ? 'bg-green-100 text-green-700' :
                isRefused ? 'bg-red-100 text-red-700' :
                currentStatut.code === 'octroye' ? 'bg-green-100 text-green-700' :
                'bg-blue-100 text-blue-700'
              }`}>
                {currentStatut?.label || 'Nouveau'} {!isRefused && currentStatut?.progress !== undefined && `- ${currentStatut.progress}%`}
              </span>
            </div>
            
            {/* Barre de progression */}
            <div className="relative">
              <div className={`h-2.5 ${isRefused ? 'bg-red-100' : 'bg-gray-200'} rounded-full overflow-hidden`}>
                <div 
                  className={`h-full ${isRefused ? 'bg-red-500' : currentStatut.couleur} transition-all duration-500 rounded-full`}
                  style={{ width: isRefused ? '100%' : `${currentStatut.progress}%` }}
                ></div>
              </div>
              
              {/* Étapes */}
              {!isRefused && (
                <div className="flex justify-between mt-2">
                  {progressionStatuts.map((s, idx) => {
                    const isActive = idx <= currentIndex && currentIndex >= 0;
                    const isCurrent = s.code === dossier?.statut;
                    return (
                      <div key={s.code} className="flex flex-col items-center flex-1">
                        <div className={`w-3 h-3 rounded-full transition-all ${
                          isCurrent ? `${s.couleur} ring-2 ring-offset-1 ring-blue-300` :
                          isActive ? 'bg-green-500' : 'bg-gray-300'
                        }`}></div>
                        <span className={`text-xs mt-1 text-center leading-tight ${
                          isCurrent ? 'font-semibold text-gray-900' : 
                          isActive ? 'text-green-600' : 'text-gray-400'
                        }`}>
                          {s.label}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
              
              {/* Message refusé */}
              {isRefused && (
                <div className="flex items-center justify-center mt-2 text-red-600">
                  <AlertTriangle className="w-4 h-4 mr-1" />
                  <span className="text-sm font-semibold">Dossier refusé</span>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Tabs */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="flex border-b border-gray-200 overflow-x-auto">
          <button
            onClick={() => setActiveTab('dossier')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'dossier'
                ? 'border-green-600 text-green-600 bg-green-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
          >
            <FileText className="w-4 h-4" />
            Dossier
          </button>
          <button
            onClick={() => setActiveTab('installateur')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'installateur'
                ? 'border-orange-600 text-orange-600 bg-orange-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
            data-testid="tab-installateur"
          >
            <Hammer className="w-4 h-4" />
            Installateur
          </button>
          <button
            onClick={() => setActiveTab('amo')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'amo'
                ? 'border-teal-600 text-teal-600 bg-teal-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
            data-testid="tab-amo"
          >
            <Building2 className="w-4 h-4" />
            AMO
          </button>
          <button
            onClick={() => setActiveTab('documents')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'documents'
                ? 'border-green-600 text-green-600 bg-green-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
            data-testid="tab-documents"
          >
            <FolderOpen className="w-4 h-4" />
            Documents
          </button>
          <button
            onClick={() => setActiveTab('suivi')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'suivi'
                ? 'border-green-600 text-green-600 bg-green-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
          >
            <Activity className="w-4 h-4" />
            Suivi ({suivis.length})
          </button>
          <button
            onClick={() => setActiveTab('remarques')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'remarques'
                ? 'border-green-600 text-green-600 bg-green-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
          >
            <MessageCircle className="w-4 h-4" />
            Remarques ({remarques.length})
          </button>
          <button
            onClick={() => setActiveTab('messagerie')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'messagerie'
                ? 'border-green-600 text-green-600 bg-green-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
            data-testid="tab-messagerie"
          >
            <Mail className="w-4 h-4" />
            Messagerie
          </button>
          <button
            onClick={() => setActiveTab('recap')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'recap'
                ? 'border-purple-600 text-purple-600 bg-purple-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
            data-testid="tab-recap"
          >
            <ClipboardList className="w-4 h-4" />
            Récap
          </button>
          <button
            onClick={() => setActiveTab('details')}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition border-b-2 ${
              activeTab === 'details'
                ? 'border-green-600 text-green-600 bg-green-50'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
            data-testid="tab-details-dossier"
          >
            <Clock className="w-4 h-4" />
            Détail
          </button>
        </div>

        <div className="p-4">
          {/* Onglet Récap */}
          {activeTab === 'recap' && (
            <div className="space-y-6">
              {/* Header Récap */}
              <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-xl p-6 text-white">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                    <ClipboardList className="w-6 h-6" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">Récapitulatif complet</h2>
                    <p className="text-purple-100">Toutes les informations du dossier en un coup d'œil</p>
                  </div>
                </div>
              </div>

              {/* Grille Récap */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                
                {/* Bloc Client */}
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="bg-blue-50 px-4 py-3 border-b border-blue-100 flex items-center justify-between">
                    <h3 className="font-bold text-blue-800 flex items-center gap-2">
                      <User className="w-5 h-5" />
                      Client
                    </h3>
                    
                    {/* Bouton Handicap */}
                    <button
                      onClick={async () => {
                        if (!dossier.is_handicap) {
                          // Activer le handicap
                          setHandicapExpanded(true);
                          try {
                            await dossiersAPI.update(dossier.id, { is_handicap: true });
                            setDossier(prev => ({ ...prev, is_handicap: true }));
                          } catch (e) {
                            console.error('Erreur activation handicap:', e);
                          }
                        } else {
                          // Toggle le menu déroulant
                          setHandicapExpanded(!handicapExpanded);
                        }
                      }}
                      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all ${
                        dossier.is_handicap 
                          ? 'bg-purple-100 text-purple-700 hover:bg-purple-200 ring-2 ring-purple-400' 
                          : 'bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600'
                      }`}
                      title={dossier.is_handicap ? 'Personne en situation de handicap' : 'Cliquer pour indiquer un handicap'}
                      data-testid="handicap-toggle-btn"
                    >
                      <Accessibility className={`w-5 h-5 ${dossier.is_handicap ? 'text-purple-600' : ''}`} />
                      {dossier.is_handicap && (
                        <>
                          <span className="text-xs font-semibold">
                            {dossier.taux_handicap ? `${dossier.taux_handicap}%` : 'Handicap'}
                          </span>
                          <ChevronDown className={`w-4 h-4 transition-transform ${handicapExpanded ? 'rotate-180' : ''}`} />
                        </>
                      )}
                    </button>
                  </div>
                  
                  {/* Menu déroulant Handicap */}
                  {handicapExpanded && dossier.is_handicap && (
                    <div className="bg-purple-50 border-b border-purple-200 p-3">
                      <div className="flex items-center gap-3">
                        <label className="text-sm font-medium text-purple-700">Taux d'incapacité :</label>
                        <select
                          value={dossier.taux_handicap || ''}
                          onChange={async (e) => {
                            const taux = e.target.value;
                            setSavingHandicap(true);
                            try {
                              await dossiersAPI.update(dossier.id, { taux_handicap: taux ? parseInt(taux) : null });
                              setDossier(prev => ({ ...prev, taux_handicap: taux ? parseInt(taux) : null }));
                            } catch (err) {
                              console.error('Erreur sauvegarde taux handicap:', err);
                            } finally {
                              setSavingHandicap(false);
                            }
                          }}
                          className="flex-1 max-w-[150px] px-3 py-1.5 border border-purple-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-500 bg-white"
                          data-testid="handicap-taux-select"
                        >
                          <option value="">Non renseigné</option>
                          <option value="50">50% - 79%</option>
                          <option value="80">≥ 80%</option>
                        </select>
                        
                        <button
                          onClick={async () => {
                            setSavingHandicap(true);
                            try {
                              await dossiersAPI.update(dossier.id, { is_handicap: false, taux_handicap: null });
                              setDossier(prev => ({ ...prev, is_handicap: false, taux_handicap: null }));
                              setHandicapExpanded(false);
                            } catch (err) {
                              console.error('Erreur désactivation handicap:', err);
                            } finally {
                              setSavingHandicap(false);
                            }
                          }}
                          className="text-xs text-purple-600 hover:text-red-600 hover:underline"
                        >
                          Retirer
                        </button>
                        
                        {savingHandicap && <Loader2 className="w-4 h-4 animate-spin text-purple-500" />}
                      </div>
                    </div>
                  )}
                  
                  <div className="p-4 space-y-3">
                    <div className="text-lg font-semibold text-gray-900">
                      {dossier.identite?.nom} {dossier.identite?.prenom}
                    </div>
                    <div className="space-y-2 text-sm">
                      {dossier.identite?.telephone && (
                        <div className="flex items-center gap-2 text-gray-700">
                          <Phone className="w-4 h-4 text-blue-500" />
                          <span className="font-medium">{dossier.identite.telephone}</span>
                        </div>
                      )}
                      {dossier.identite?.email && (
                        <div className="flex items-center gap-2 text-gray-700">
                          <Mail className="w-4 h-4 text-blue-500" />
                          <span>{dossier.identite.email}</span>
                        </div>
                      )}
                      {(dossier.identite?.nss || dossier.identite?.numero_securite_sociale) && (
                        <div className="flex items-center gap-2 text-gray-700">
                          <CreditCard className="w-4 h-4 text-blue-500" />
                          <span className="font-mono">{dossier.identite.nss || dossier.identite.numero_securite_sociale} / {dossier.identite.cle_nss || dossier.identite.cle_securite_sociale}</span>
                        </div>
                      )}
                      {dossier.identite?.adresse && (
                        <div className="flex items-start gap-2 text-gray-700">
                          <MapPin className="w-4 h-4 text-blue-500 mt-0.5" />
                          <span>{dossier.identite.adresse}, {dossier.identite.code_postal} {dossier.identite.ville}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Bloc Caisse */}
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="bg-indigo-50 px-4 py-3 border-b border-indigo-100">
                    <h3 className="font-bold text-indigo-800 flex items-center gap-2">
                      <Globe className="w-5 h-5" />
                      Caisse de retraite
                    </h3>
                  </div>
                  <div className="p-4">
                    {dossier.caisse ? (
                      <div className="space-y-2">
                        <div className="text-lg font-semibold text-gray-900">{dossier.caisse}</div>
                        {(() => {
                          const caisseInfo = caisses.find(c => c.nom === dossier.caisse);
                          if (caisseInfo) {
                            return (
                              <div className="space-y-1 text-sm text-gray-600">
                                {caisseInfo.telephone && (
                                  <div className="flex items-center gap-2">
                                    <Phone className="w-4 h-4 text-indigo-500" />
                                    {caisseInfo.telephone}
                                  </div>
                                )}
                                {caisseInfo.email && (
                                  <div className="flex items-center gap-2">
                                    <Mail className="w-4 h-4 text-indigo-500" />
                                    {caisseInfo.email}
                                  </div>
                                )}
                              </div>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    ) : (
                      <div className="text-gray-400 italic">Non renseignée</div>
                    )}
                  </div>
                </div>

                {/* Bloc AMO */}
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="bg-teal-50 px-4 py-3 border-b border-teal-100">
                    <h3 className="font-bold text-teal-800 flex items-center gap-2">
                      <Building2 className="w-5 h-5" />
                      AMO & ANAH
                    </h3>
                  </div>
                  <div className="p-4">
                    {amoData.amo_id ? (
                      <div className="space-y-3">
                        {(() => {
                          const amo = amoList.find(a => a.id === amoData.amo_id);
                          return amo ? (
                            <div>
                              <div className="font-semibold text-gray-900">{amo.nom}</div>
                              {amo.contact && <div className="text-sm text-gray-600">{amo.contact}</div>}
                              {amo.telephone && (
                                <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
                                  <Phone className="w-4 h-4 text-teal-500" />
                                  {amo.telephone}
                                </div>
                              )}
                            </div>
                          ) : null;
                        })()}
                        <div className="border-t pt-3 space-y-1">
                          <div className="flex items-center justify-between text-sm">
                            <span className="text-gray-600">Demande ANAH</span>
                            <span className={`font-medium ${amoData.anah_demande_faite ? 'text-green-600' : 'text-gray-400'}`}>
                              {amoData.anah_demande_faite ? '✅ Faite' : '❌ Non'}
                            </span>
                          </div>
                          {amoData.anah_demande_faite && (
                            <div className="flex items-center justify-between text-sm">
                              <span className="text-gray-600">Réponse</span>
                              <span className={`font-medium ${
                                amoData.anah_statut === 'valide' ? 'text-green-600' : 
                                amoData.anah_statut === 'refuse' ? 'text-red-600' : 
                                amoData.anah_reponse_recue ? 'text-yellow-600' : 'text-gray-400'
                              }`}>
                                {amoData.anah_statut === 'valide' ? '✅ Validé' : 
                                 amoData.anah_statut === 'refuse' ? '❌ Refusé' : 
                                 amoData.anah_statut === 'en_attente' ? '⏳ En attente' :
                                 amoData.anah_reponse_recue ? '📩 Reçue' : '⏳ En attente'}
                              </span>
                            </div>
                          )}
                          {amoData.anah_budget_accorde && (
                            <div className="flex items-center justify-between text-sm">
                              <span className="text-gray-600">Budget ANAH</span>
                              <span className="font-bold text-green-600">{parseFloat(amoData.anah_budget_accorde).toLocaleString('fr-FR')} €</span>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="text-gray-400 italic">Aucun AMO sélectionné</div>
                    )}
                  </div>
                </div>

                {/* Bloc Installateur */}
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="bg-orange-50 px-4 py-3 border-b border-orange-100">
                    <h3 className="font-bold text-orange-800 flex items-center gap-2">
                      <Hammer className="w-5 h-5" />
                      Installateur & Travaux
                    </h3>
                  </div>
                  <div className="p-4">
                    {installateurData.nom_installateur ? (
                      <div className="space-y-3">
                        <div>
                          <div className="font-semibold text-gray-900">{installateurData.nom_installateur}</div>
                          {(() => {
                            const inst = installateursList.find(i => i.id === installateurData.installateur_id);
                            return inst?.telephone ? (
                              <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
                                <Phone className="w-4 h-4 text-orange-500" />
                                {inst.telephone}
                              </div>
                            ) : null;
                          })()}
                        </div>
                        <div className="border-t pt-3 space-y-2">
                          <div className="flex items-center justify-between text-sm">
                            <span className="text-gray-600">Statut travaux</span>
                            <span className={`font-medium ${
                              installateurData.statut_travaux === 'termines' ? 'text-green-600' : 
                              installateurData.statut_travaux === 'en_cours' ? 'text-blue-600' : 'text-gray-500'
                            }`}>
                              {installateurData.statut_travaux === 'termines' ? '✅ Terminés' : 
                               installateurData.statut_travaux === 'en_cours' ? '🔧 En cours' : 
                               installateurData.statut_travaux === 'non_demarre' ? '⏳ Non démarrés' : '—'}
                            </span>
                          </div>
                          {installateurData.montant_devis && (
                            <div className="flex items-center justify-between text-sm">
                              <span className="text-gray-600">Devis</span>
                              <span className="font-semibold">{parseFloat(installateurData.montant_devis).toLocaleString('fr-FR')} €</span>
                            </div>
                          )}
                          {installateurData.montant_anah && (
                            <div className="flex items-center justify-between text-sm">
                              <span className="text-gray-600">Aide ANAH</span>
                              <span className="font-semibold text-green-600">{parseFloat(installateurData.montant_anah).toLocaleString('fr-FR')} €</span>
                            </div>
                          )}
                          {installateurData.montant_paye_client && (
                            <div className="flex items-center justify-between text-sm">
                              <span className="text-gray-600">Déjà payé</span>
                              <span className="font-semibold text-purple-600">{parseFloat(installateurData.montant_paye_client).toLocaleString('fr-FR')} €</span>
                            </div>
                          )}
                          {(installateurData.montant_devis || installateurData.montant_anah) && (
                            <div className="flex items-center justify-between text-sm pt-1 border-t border-gray-200 mt-1">
                              <span className="text-gray-700 font-medium">Reste à payer</span>
                              <span className={`font-bold ${
                                ((parseFloat(installateurData.montant_devis) || 0) - (parseFloat(installateurData.montant_anah) || 0) - (parseFloat(installateurData.montant_paye_client) || 0)) <= 0 
                                  ? 'text-green-600' 
                                  : 'text-orange-600'
                              }`}>
                                {((parseFloat(installateurData.montant_devis) || 0) - (parseFloat(installateurData.montant_anah) || 0) - (parseFloat(installateurData.montant_paye_client) || 0)).toLocaleString('fr-FR')} €
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="text-gray-400 italic">Aucun installateur</div>
                    )}
                  </div>
                </div>
              </div>

              {/* Barre de progression du Parcours Organisme */}
              {dossier.caisse && organisme && (
                <ParcoursProgress 
                  dossierId={dossier.id}
                  caisseNom={dossier.caisse}
                  caisseId={organisme?.id}
                  etapeActuelle={dossier.etape_parcours || etapeParcoursActuelle}
                  onUpdateEtape={async (etapeId, etapeLabel) => {
                    try {
                      await dossiersAPI.update(dossier.id, { etape_parcours: etapeId, etape_parcours_label: etapeLabel });
                      setEtapeParcoursActuelle(etapeId);
                      setDossier(prev => ({ ...prev, etape_parcours: etapeId, etape_parcours_label: etapeLabel }));
                    } catch (error) {
                      console.error('Erreur mise à jour étape:', error);
                    }
                  }}
                />
              )}

              {/* Bloc Ressources & Charges */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Ressources */}
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="bg-green-50 px-4 py-3 border-b border-green-100">
                    <h3 className="font-bold text-green-800 flex items-center gap-2">
                      <Wallet className="w-5 h-5" />
                      Ressources mensuelles
                    </h3>
                  </div>
                  <div className="p-4">
                    <div className="space-y-2 text-sm">
                      {dossier.ressources?.retraite_base > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Retraite de base</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.retraite_base).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.ressources?.retraite_complementaire > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Retraite complémentaire</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.retraite_complementaire).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.ressources?.salaires > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Salaires</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.salaires).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.ressources?.allocation_logement > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Allocation logement</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.allocation_logement).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.ressources?.rsa_prime_activite > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">RSA / Prime activité</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.rsa_prime_activite).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.ressources?.aah_aeeh_pch > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">AAH / AEEH / PCH</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.aah_aeeh_pch).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.ressources?.pension_invalidite_ss > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Pension invalidité</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.pension_invalidite_ss).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.ressources?.autres_revenus > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Autres revenus</span>
                          <span className="font-medium">{parseFloat(dossier.ressources.autres_revenus).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      <div className="border-t pt-2 mt-2">
                        <div className="flex justify-between font-bold text-green-700">
                          <span>TOTAL</span>
                          <span>
                            {(() => {
                              const total = (
                                parseFloat(dossier.ressources?.retraite_base || 0) +
                                parseFloat(dossier.ressources?.retraite_complementaire || 0) +
                                parseFloat(dossier.ressources?.salaires || 0) +
                                parseFloat(dossier.ressources?.allocation_logement || 0) +
                                parseFloat(dossier.ressources?.rsa_prime_activite || 0) +
                                parseFloat(dossier.ressources?.aah_aeeh_pch || 0) +
                                parseFloat(dossier.ressources?.pension_invalidite_ss || 0) +
                                parseFloat(dossier.ressources?.autres_revenus || 0)
                              );
                              return total.toLocaleString('fr-FR') + ' €';
                            })()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Charges */}
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="bg-red-50 px-4 py-3 border-b border-red-100">
                    <h3 className="font-bold text-red-800 flex items-center gap-2">
                      <CreditCard className="w-5 h-5" />
                      Charges mensuelles
                    </h3>
                  </div>
                  <div className="p-4">
                    <div className="space-y-2 text-sm">
                      {dossier.charges?.loyer > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Loyer</span>
                          <span className="font-medium">{parseFloat(dossier.charges.loyer).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.energie > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Énergie</span>
                          <span className="font-medium">{parseFloat(dossier.charges.energie).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.eau > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Eau</span>
                          <span className="font-medium">{parseFloat(dossier.charges.eau).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.assurance_habitation > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Assurance habitation</span>
                          <span className="font-medium">{parseFloat(dossier.charges.assurance_habitation).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.assurance_vehicule > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Assurance véhicule</span>
                          <span className="font-medium">{parseFloat(dossier.charges.assurance_vehicule).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.telephonie > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Téléphonie / Internet</span>
                          <span className="font-medium">{parseFloat(dossier.charges.telephonie).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.cotisations_mutuelle > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Mutuelle</span>
                          <span className="font-medium">{parseFloat(dossier.charges.cotisations_mutuelle).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.impot_revenu > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Impôt sur le revenu</span>
                          <span className="font-medium">{parseFloat(dossier.charges.impot_revenu).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      {dossier.charges?.autres_charges > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Autres charges</span>
                          <span className="font-medium">{parseFloat(dossier.charges.autres_charges).toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      <div className="border-t pt-2 mt-2">
                        <div className="flex justify-between font-bold text-red-700">
                          <span>TOTAL</span>
                          <span>
                            {(() => {
                              const total = (
                                parseFloat(dossier.charges?.loyer || 0) +
                                parseFloat(dossier.charges?.energie || 0) +
                                parseFloat(dossier.charges?.eau || 0) +
                                parseFloat(dossier.charges?.assurance_habitation || 0) +
                                parseFloat(dossier.charges?.assurance_vehicule || 0) +
                                parseFloat(dossier.charges?.telephonie || 0) +
                                parseFloat(dossier.charges?.cotisations_mutuelle || 0) +
                                parseFloat(dossier.charges?.impot_revenu || 0) +
                                parseFloat(dossier.charges?.autres_charges || 0)
                              );
                              return total.toLocaleString('fr-FR') + ' €';
                            })()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Reste à vivre */}
              <div className="bg-gradient-to-r from-purple-100 to-indigo-100 rounded-xl p-6 border border-purple-200">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-purple-800">Reste à vivre mensuel</h3>
                    <p className="text-purple-600 text-sm">Ressources - Charges</p>
                  </div>
                  <div className="text-right">
                    {(() => {
                      const totalRessources = (
                        parseFloat(dossier.ressources?.retraite_base || 0) +
                        parseFloat(dossier.ressources?.retraite_complementaire || 0) +
                        parseFloat(dossier.ressources?.salaires || 0) +
                        parseFloat(dossier.ressources?.allocation_logement || 0) +
                        parseFloat(dossier.ressources?.rsa_prime_activite || 0) +
                        parseFloat(dossier.ressources?.aah_aeeh_pch || 0) +
                        parseFloat(dossier.ressources?.pension_invalidite_ss || 0) +
                        parseFloat(dossier.ressources?.autres_revenus || 0)
                      );
                      const totalCharges = (
                        parseFloat(dossier.charges?.loyer || 0) +
                        parseFloat(dossier.charges?.energie || 0) +
                        parseFloat(dossier.charges?.eau || 0) +
                        parseFloat(dossier.charges?.assurance_habitation || 0) +
                        parseFloat(dossier.charges?.assurance_vehicule || 0) +
                        parseFloat(dossier.charges?.telephonie || 0) +
                        parseFloat(dossier.charges?.cotisations_mutuelle || 0) +
                        parseFloat(dossier.charges?.impot_revenu || 0) +
                        parseFloat(dossier.charges?.autres_charges || 0)
                      );
                      const resteAVivre = totalRessources - totalCharges;
                      return (
                        <span className={`text-3xl font-bold ${resteAVivre >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                          {resteAVivre.toLocaleString('fr-FR')} €
                        </span>
                      );
                    })()}
                    <div className="text-purple-600 text-sm">par mois</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Onglet Dossier */}
          {activeTab === 'dossier' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Main Content - Fiche Dynamique */}
              <div className="lg:col-span-2">
                <DynamicDossierView 
                  dossier={dossier}
                  editing={editing}
                  editData={editData}
                  setEditData={setEditData}
                  statuts={statuts}
                  gestionnaires={gestionnaires}
                />
              </div>

              {/* Sidebar */}
              <div className="space-y-4">
                {/* Demandes d'aide - Cases à cocher simples */}
                {(organisme || departementInfo) && (
                  <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                    <h3 className="text-sm font-bold text-gray-900 mb-3">Aides sollicitées</h3>
                    
                    <div className="space-y-2">
                      {/* Caisse complémentaire */}
                      {organisme && (
                        <label className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition ${
                          aideCaisse ? 'border-green-500 bg-green-50' : 'border-gray-200 bg-gray-50 hover:border-gray-300'
                        }`}>
                          <input
                            type="checkbox"
                            checked={aideCaisse}
                            onChange={(e) => setAideCaisse(e.target.checked)}
                            className="w-5 h-5 rounded text-green-600 focus:ring-green-500"
                          />
                          <div>
                            <span className="text-sm font-medium text-gray-900">{organisme.nom}</span>
                            {aideCaisse && <span className="ml-2 text-xs text-green-600">✓ Sollicitée</span>}
                          </div>
                        </label>
                      )}
                      
                      {/* Département */}
                      {departementInfo && (
                        <label className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition ${
                          aideDepartement ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-gray-50 hover:border-gray-300'
                        }`}>
                          <input
                            type="checkbox"
                            checked={aideDepartement}
                            onChange={(e) => setAideDepartement(e.target.checked)}
                            className="w-5 h-5 rounded text-blue-600 focus:ring-blue-500"
                          />
                          <div>
                            <span className="text-sm font-medium text-gray-900">Dép. {departementInfo.code} - {departementInfo.nom}</span>
                            {aideDepartement && <span className="ml-2 text-xs text-blue-600">✓ Sollicitée</span>}
                          </div>
                        </label>
                      )}
                    </div>
                  </div>
                )}
                
                {/* Contact Caisse complémentaire */}
                {organisme && (
                  <div className="bg-gradient-to-br from-purple-50 to-pink-50 border border-purple-200 rounded-xl p-4">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                        {organisme.nom[0]}
                      </div>
                      <div>
                        <h2 className="text-sm font-bold text-gray-900">{organisme.nom}</h2>
                        <p className="text-xs text-gray-600">{organisme.horaires}</p>
                      </div>
                    </div>

                    <div className="space-y-2">
                      <a href={`tel:${organisme.telephone}`} className="flex items-center gap-2 p-2 bg-white rounded-lg hover:bg-gray-50 transition">
                        <Phone className="w-4 h-4 text-green-600" />
                        <div>
                          <div className="text-xs text-gray-500">Téléphone</div>
                          <div className="font-medium text-gray-900 text-sm">{organisme.telephone}</div>
                        </div>
                      </a>

                      <a href={`mailto:${organisme.email}`} className="flex items-center gap-2 p-2 bg-white rounded-lg hover:bg-gray-50 transition">
                        <Mail className="w-4 h-4 text-blue-600" />
                        <div>
                          <div className="text-xs text-gray-500">Email</div>
                          <div className="font-medium text-gray-900 text-xs">{organisme.email}</div>
                        </div>
                      </a>

                      {organisme.site_web && (
                        <a href={organisme.site_web} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 p-2 bg-white rounded-lg hover:bg-gray-50 transition">
                          <Globe className="w-4 h-4 text-purple-600" />
                          <div>
                            <div className="text-xs text-gray-500">Site internet</div>
                            <div className="font-medium text-blue-600 text-xs hover:underline">Visiter le site</div>
                          </div>
                        </a>
                      )}
                    </div>
                  </div>
                )}

                {/* Contact Département */}
                {departementInfo && (
                  <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white text-lg">
                        🏛️
                      </div>
                      <div>
                        <h2 className="text-sm font-bold text-gray-900">{departementInfo.fullName || departementInfo.nom}</h2>
                        <p className="text-xs text-gray-600">Conseil départemental</p>
                      </div>
                    </div>

                    <div className="space-y-2">
                      {departementInfo.telephone && (
                        <a href={`tel:${departementInfo.telephone}`} className="flex items-center gap-2 p-2 bg-white rounded-lg hover:bg-gray-50 transition text-sm">
                          <Phone className="w-4 h-4 text-green-600" />
                          <div>
                            <div className="text-xs text-gray-500">Téléphone</div>
                            <div className="font-medium text-gray-900">{departementInfo.telephone}</div>
                          </div>
                        </a>
                      )}

                      {departementInfo.email && (
                        <a href={`mailto:${departementInfo.email}`} className="flex items-center gap-2 p-2 bg-white rounded-lg hover:bg-gray-50 transition text-sm">
                          <Mail className="w-4 h-4 text-blue-600" />
                          <div>
                            <div className="text-xs text-gray-500">Email</div>
                            <div className="font-medium text-gray-900 text-xs">{departementInfo.email}</div>
                          </div>
                        </a>
                      )}

                      {departementInfo.adresse && (
                        <div className="flex items-center gap-2 p-2 bg-white rounded-lg text-sm">
                          <Home className="w-4 h-4 text-gray-600" />
                          <div>
                            <div className="text-xs text-gray-500">Adresse</div>
                            <div className="font-medium text-gray-900 text-xs">{departementInfo.adresse}</div>
                          </div>
                        </div>
                      )}

                      {departementInfo.site_web && (
                        <a href={departementInfo.site_web} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 p-2 bg-white rounded-lg hover:bg-gray-50 transition text-sm">
                          <Globe className="w-4 h-4 text-purple-600" />
                          <div>
                            <div className="text-xs text-gray-500">Site internet</div>
                            <div className="font-medium text-blue-600 text-xs hover:underline">Visiter le site</div>
                          </div>
                        </a>
                      )}
                    </div>
                  </div>
                )}

                {/* Assistant IA - Version améliorée */}
                {showAI && (
                  <AgentIAChat 
                    dossierId={dossier.id} 
                    dossierInfo={dossier}
                    onActionExecuted={() => loadData()}
                  />
                )}
              </div>
            </div>
          )}
          {/* Onglet Suivi - Dynamique */}
          {activeTab === 'suivi' && (
            <DynamicSuiviView 
              dossierId={dossier.id}
              user={user}
              onUpdate={loadData}
            />
          )}

          {/* Onglet Remarques */}
          {activeTab === 'remarques' && (
            <div className="space-y-4">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold text-gray-900">📝 Remarques internes</h2>
                <span className="text-sm text-gray-600">{remarques.length} remarque(s)</span>
              </div>

              {/* Formulaire nouvelle remarque */}
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 mb-6">
                <div className="flex flex-wrap gap-2 mb-3">
                  {Object.entries(categoriesRemarques).map(([key, cat]) => (
                    <button
                      key={key}
                      onClick={() => setNewRemarqueCategorie(key)}
                      className={`px-3 py-1.5 rounded-lg text-sm font-medium border transition ${
                        newRemarqueCategorie === key
                          ? cat.color + ' ring-2 ring-offset-1 ring-gray-400'
                          : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-100'
                      }`}
                    >
                      {cat.icon} {cat.label}
                    </button>
                  ))}
                </div>
                <div className="flex gap-2">
                  <textarea
                    value={newRemarque}
                    onChange={(e) => setNewRemarque(e.target.value)}
                    placeholder="Ajouter une remarque..."
                    rows="2"
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                  />
                  <button
                    onClick={handleAddRemarque}
                    disabled={!newRemarque.trim()}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                  >
                    <Send className="w-5 h-5" />
                    Ajouter
                  </button>
                </div>
              </div>

              {/* Liste des remarques */}
              <div className="space-y-3 max-h-[500px] overflow-y-auto">
                {remarques.map((remarque) => {
                  const cat = categoriesRemarques[remarque.categorie] || categoriesRemarques.info;
                  return (
                    <div key={remarque.id} className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-sm transition group">
                      <div className="flex items-start gap-3">
                        <span className={`px-2.5 py-1 rounded-lg text-xs font-medium border ${cat.color}`}>
                          {cat.icon} {cat.label}
                        </span>
                        <div className="flex-1 min-w-0">
                          <p className="text-gray-900 whitespace-pre-wrap">{remarque.message}</p>
                          <div className="flex items-center gap-3 mt-2 text-xs text-gray-500">
                            <span className="font-medium">{remarque.user_nom}</span>
                            <span>•</span>
                            <span>{new Date(remarque.date_creation).toLocaleString('fr-FR')}</span>
                          </div>
                        </div>
                        <button
                          onClick={() => handleDeleteRemarque(remarque.id)}
                          className="opacity-0 group-hover:opacity-100 p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition"
                          title="Supprimer cette remarque"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  );
                })}

                {remarques.length === 0 && (
                  <div className="text-center py-12 text-gray-500">
                    <MessageCircle className="w-12 h-12 mx-auto mb-3 text-gray-400" />
                    <p>Aucune remarque pour le moment</p>
                    <p className="text-sm mt-2">Ajoutez une remarque ci-dessus</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Onglet Détail du dossier */}
          {activeTab === 'details' && (
            <div className="space-y-6">
              {/* Informations générales */}
              {(isElementVisible('reference') || isElementVisible('date_creation') || isElementVisible('date_modification') || isElementVisible('caisse')) && (
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <FileText className="w-5 h-5 text-green-600" />
                    Informations générales
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {isElementVisible('reference') && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Référence</label>
                        <p className="font-semibold text-gray-900">{dossier.reference}</p>
                      </div>
                    )}
                    {isElementVisible('date_creation') && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Date création</label>
                        <p className="font-medium text-gray-900">{new Date(dossier.date_creation).toLocaleDateString('fr-FR')}</p>
                      </div>
                    )}
                    {isElementVisible('date_modification') && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Dernière modification</label>
                        <p className="font-medium text-gray-900">{new Date(dossier.date_modification).toLocaleDateString('fr-FR')}</p>
                      </div>
                    )}
                    {isElementVisible('caisse') && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Caisse</label>
                        <p className="font-medium text-gray-900">{dossier.caisse}</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Statut et Priorité */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {isElementVisible('statut') && (
                  <div className="bg-white border border-gray-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-bold text-gray-900">📊 Statut du dossier</h3>
                      {editingField !== 'statut' && (
                        <button
                          onClick={() => startEditingField('statut', dossier.statut)}
                          className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
                          title="Modifier le statut"
                          data-testid="edit-statut-btn"
                        >
                          <Edit3 className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                    {editingField === 'statut' ? (
                      <div className="space-y-3">
                        <select
                          value={editingValue}
                          onChange={(e) => setEditingValue(e.target.value)}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                          data-testid="edit-statut-select"
                        >
                          {statuts.filter(s => s.actif).map(s => (
                            <option key={s.code} value={s.code}>{s.icone} {s.label}</option>
                          ))}
                        </select>
                        <div className="flex gap-2">
                          <button onClick={saveFieldEdit} disabled={savingField} className="flex-1 px-3 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-1">
                            {savingField ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                            Enregistrer
                          </button>
                          <button onClick={cancelEditingField} className="px-3 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50">
                            Annuler
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm text-gray-600 mb-2">Statut actuel</label>
                          {statusBadge.style ? (
                            <span className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold ${statusBadge.class}`} style={statusBadge.style}>
                              {statusBadge.icone} {statusBadge.label}
                            </span>
                          ) : (
                            <span className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold ${statusBadge.class}`}>
                              {statusBadge.label}
                            </span>
                          )}
                        </div>
                        {isElementVisible('resultat') && dossier.date_cloture && (
                          <div>
                            <label className="block text-sm text-gray-600 mb-1">Date de clôture</label>
                            <p className="font-medium text-gray-900">{new Date(dossier.date_cloture).toLocaleDateString('fr-FR')}</p>
                          </div>
                        )}
                        {isElementVisible('resultat') && dossier.resultat && (
                          <div>
                            <label className="block text-sm text-gray-600 mb-1">Résultat</label>
                            <p className="font-medium text-gray-900">{dossier.resultat}</p>
                          </div>
                        )}
                        {isElementVisible('montant') && dossier.montant && (
                          <div>
                            <label className="block text-sm text-gray-600 mb-1">Montant accordé</label>
                            <p className="font-bold text-green-600 text-lg">{dossier.montant.toLocaleString('fr-FR')} €</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {isElementVisible('priorite') && (
                  <div className="bg-white border border-gray-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-bold text-gray-900">⚡ Priorité</h3>
                      {editingField !== 'priorite' && (
                        <button
                          onClick={() => startEditingField('priorite', dossier.priorite || '')}
                          className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
                          title="Modifier la priorité"
                          data-testid="edit-priorite-btn"
                        >
                          <Edit3 className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                    {editingField === 'priorite' ? (
                      <div className="space-y-3">
                        <select
                          value={editingValue}
                          onChange={(e) => setEditingValue(e.target.value)}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                          data-testid="edit-priorite-select"
                        >
                          <option value="">⚪ Aucune</option>
                          <option value="low">🟢 Basse</option>
                          <option value="med">🟠 Moyenne</option>
                          <option value="high">🔴 Haute</option>
                        </select>
                        <div className="flex gap-2">
                          <button onClick={saveFieldEdit} disabled={savingField} className="flex-1 px-3 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-1">
                            {savingField ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                            Enregistrer
                          </button>
                          <button onClick={cancelEditingField} className="px-3 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50">
                            Annuler
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center gap-3">
                        <span className="text-3xl">
                          {!dossier.priorite ? '⚪' : dossier.priorite === 'high' ? '🔴' : dossier.priorite === 'med' ? '🟠' : '🟢'}
                        </span>
                        <div>
                          <p className="font-semibold text-gray-900 text-lg">
                            {!dossier.priorite ? 'Aucune priorité' : dossier.priorite === 'high' ? 'Haute priorité' : dossier.priorite === 'med' ? 'Priorité moyenne' : 'Priorité basse'}
                          </p>
                          <p className="text-sm text-gray-500">
                            {!dossier.priorite ? 'Non définie' : dossier.priorite === 'high' ? 'Traitement urgent requis' : dossier.priorite === 'med' ? 'Traitement dans les délais normaux' : 'Peut attendre'}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Gestionnaire et Source */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {isElementVisible('gestionnaire') && (
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                        <User className="w-5 h-5 text-blue-600" />
                        Gestionnaire assigné
                      </h3>
                      {editingField !== 'gestionnaire' && (
                        <button
                          onClick={() => startEditingField('gestionnaire', dossier.gestionnaire_id || '')}
                          className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-100 rounded-lg transition"
                          title="Modifier le gestionnaire"
                          data-testid="edit-gestionnaire-btn"
                        >
                          <Edit3 className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                    {editingField === 'gestionnaire' ? (
                      <div className="space-y-3">
                        <select
                          value={editingValue}
                          onChange={(e) => setEditingValue(e.target.value)}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                          data-testid="edit-gestionnaire-select"
                        >
                          <option value="">— Non assigné —</option>
                          {gestionnaires.map(g => (
                            <option key={g.id} value={g.id}>{g.prenom} {g.nom}</option>
                          ))}
                        </select>
                        <div className="flex gap-2">
                          <button onClick={saveFieldEdit} disabled={savingField} className="flex-1 px-3 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-1">
                            {savingField ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                            Enregistrer
                          </button>
                          <button onClick={cancelEditingField} className="px-3 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50">
                            Annuler
                          </button>
                        </div>
                      </div>
                    ) : dossier.gestionnaire_nom ? (
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                          {dossier.gestionnaire_nom.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">{dossier.gestionnaire_nom}</p>
                          <p className="text-sm text-gray-500">Responsable du dossier</p>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center py-4 text-gray-500">
                        <User className="w-10 h-10 mx-auto mb-2 text-gray-400" />
                        <p>Aucun gestionnaire assigné</p>
                      </div>
                    )}
                  </div>
                )}

                {isElementVisible('source') && (
                  <div className="bg-purple-50 border border-purple-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                        📬 Provenance
                      </h3>
                      {editingField !== 'source' && (
                        <button
                          onClick={() => startEditingField('source', dossier.source)}
                          className="p-2 text-gray-500 hover:text-blue-600 hover:bg-purple-100 rounded-lg transition"
                          title="Modifier la source"
                          data-testid="edit-source-btn"
                        >
                          <Edit3 className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                    {editingField === 'source' ? (
                      <div className="space-y-3">
                        <select
                          value={editingValue}
                          onChange={(e) => setEditingValue(e.target.value)}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                          data-testid="edit-source-select"
                        >
                          <option value="conseiller">👤 Conseiller</option>
                          <option value="telephone">📞 Téléphone</option>
                          <option value="courrier">📬 Courrier</option>
                          <option value="lien">🔗 Lien client</option>
                        </select>
                        <div className="flex gap-2">
                          <button onClick={saveFieldEdit} disabled={savingField} className="flex-1 px-3 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-1">
                            {savingField ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                            Enregistrer
                          </button>
                          <button onClick={cancelEditingField} className="px-3 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50">
                            Annuler
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="flex items-center gap-3">
                          <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl ${
                            dossier.source === 'conseiller' ? 'bg-green-100' :
                            dossier.source === 'telephone' ? 'bg-blue-100' :
                            dossier.source === 'courrier' ? 'bg-yellow-100' : 'bg-purple-100'
                          }`}>
                            {dossier.source === 'conseiller' ? '👤' :
                             dossier.source === 'telephone' ? '📞' :
                             dossier.source === 'courrier' ? '📬' : '🔗'}
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900 capitalize">{dossier.source}</p>
                            <p className="text-sm text-gray-500">Source de la demande</p>
                          </div>
                        </div>
                        {isElementVisible('reference_externe') && dossier.reference_externe && (
                          <div className="mt-4 pt-4 border-t border-purple-200">
                            <label className="block text-xs text-gray-500 mb-1">Référence externe</label>
                            <p className="font-mono text-sm text-gray-700">{dossier.reference_externe}</p>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>

              {/* Note interne */}
              {isElementVisible('note_interne') && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                      📝 Note interne
                    </h3>
                    {editingField !== 'note_interne' && (
                      <button
                        onClick={() => startEditingField('note_interne', dossier.note_interne || '')}
                        className="p-2 text-gray-500 hover:text-blue-600 hover:bg-yellow-100 rounded-lg transition"
                        title="Modifier la note"
                        data-testid="edit-note-btn"
                      >
                        <Edit3 className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                  {editingField === 'note_interne' ? (
                    <div className="space-y-3">
                      <textarea
                        value={editingValue}
                        onChange={(e) => setEditingValue(e.target.value)}
                        rows="4"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="Saisir une note interne..."
                        data-testid="edit-note-textarea"
                      />
                      <div className="flex gap-2">
                        <button onClick={saveFieldEdit} disabled={savingField} className="flex-1 px-3 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-1">
                          {savingField ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                          Enregistrer
                        </button>
                        <button onClick={cancelEditingField} className="px-3 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50">
                          Annuler
                        </button>
                      </div>
                    </div>
                  ) : dossier.note_interne ? (
                    <p className="text-gray-700 whitespace-pre-wrap">{dossier.note_interne}</p>
                  ) : (
                    <p className="text-gray-400 italic">Aucune note interne</p>
                  )}
                </div>
              )}

              {/* Contexte de la demande */}
              {isElementVisible('contexte_demande') && dossier.contexte_demande && (
                <div className="bg-orange-50 border border-orange-200 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                    📋 Contexte de la demande
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {dossier.contexte_demande.date_evenement && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Date événement</label>
                        <p className="font-medium text-gray-900">{new Date(dossier.contexte_demande.date_evenement).toLocaleDateString('fr-FR')}</p>
                      </div>
                    )}
                    {dossier.contexte_demande.montant_factures > 0 && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Montant factures</label>
                        <p className="font-medium text-gray-900">{dossier.contexte_demande.montant_factures.toLocaleString('fr-FR')} €</p>
                      </div>
                    )}
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">Première demande</label>
                      <p className="font-medium text-gray-900">{dossier.contexte_demande.premiere_demande ? 'Oui' : 'Non'}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Onglet Installateur */}
          {activeTab === 'installateur' && (
            <div className="space-y-6">
              {/* Header moderne */}
              <div className="bg-gradient-to-r from-orange-500 to-amber-500 rounded-2xl p-6 text-white shadow-lg">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center">
                    <Hammer className="w-7 h-7" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold">Installateur & Devis</h2>
                    <p className="text-orange-100">Informations sur les travaux et financements</p>
                  </div>
                </div>
              </div>

              {/* Grille principale */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Carte Installateur */}
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                  <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
                    <h3 className="font-bold text-gray-900 flex items-center gap-2">
                      <User className="w-5 h-5 text-orange-600" />
                      Installateur
                    </h3>
                  </div>
                  <div className="p-6">
                    {/* Affichage de l'installateur sélectionné (quand sélection faite) */}
                    {installateurData.installateur_id && !showInstallateursList && !saisieManuelle && (
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Installateur sélectionné</label>
                        <div className="flex items-center gap-3 p-4 rounded-xl border-2 border-orange-500 bg-orange-50">
                          <div className="w-12 h-12 rounded-xl bg-orange-100 flex items-center justify-center">
                            <User className="w-6 h-6 text-orange-600" />
                          </div>
                          <div className="flex-1">
                            <span className="font-semibold text-orange-800 text-lg">{installateurData.nom_installateur}</span>
                            <div className="flex items-center gap-1 text-sm text-orange-600 mt-0.5">
                              <Check className="w-4 h-4" />
                              <span>Sélectionné</span>
                            </div>
                          </div>
                          <button
                            onClick={changeInstallateur}
                            className="px-4 py-2 bg-white border border-orange-300 text-orange-700 rounded-lg hover:bg-orange-50 transition text-sm font-medium"
                            data-testid="btn-changer-installateur"
                          >
                            Modifier
                          </button>
                        </div>
                      </div>
                    )}
                    
                    {/* Liste des installateurs pré-enregistrés */}
                    {installateursList.length > 0 && !saisieManuelle && showInstallateursList && (
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Sélectionner un installateur</label>
                        <div className="grid grid-cols-1 gap-2">
                          {installateursList.map((inst) => (
                            <button
                              key={inst.id}
                              onClick={() => selectInstallateur(inst)}
                              className={`flex items-center gap-3 p-3 rounded-xl border-2 transition text-left ${
                                installateurData.installateur_id === inst.id
                                  ? 'border-orange-500 bg-orange-50 text-orange-700'
                                  : 'border-gray-200 bg-white hover:border-gray-300 text-gray-700'
                              }`}
                              data-testid={`installateur-${inst.id}`}
                            >
                              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                                installateurData.installateur_id === inst.id ? 'bg-orange-100' : 'bg-gray-100'
                              }`}>
                                <User className={`w-5 h-5 ${installateurData.installateur_id === inst.id ? 'text-orange-600' : 'text-gray-500'}`} />
                              </div>
                              <span className="font-medium flex-1">{inst.nom}</span>
                              {installateurData.installateur_id === inst.id && (
                                <Check className="w-5 h-5 text-orange-600" />
                              )}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* Bouton basculer vers saisie manuelle */}
                    {showInstallateursList && (
                      <div className="flex items-center justify-between mb-3">
                        <span className="text-sm text-gray-500">
                          {saisieManuelle ? 'Saisie manuelle' : 'Ou saisir manuellement'}
                        </span>
                        <button
                          onClick={toggleSaisieManuelle}
                          className={`text-sm px-3 py-1 rounded-lg transition ${
                            saisieManuelle
                              ? 'bg-orange-100 text-orange-700'
                              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                          }`}
                        >
                          {saisieManuelle ? 'Voir la liste' : 'Saisir manuellement'}
                        </button>
                      </div>
                    )}
                    
                    {/* Champ de saisie manuelle */}
                    {(saisieManuelle || installateursList.length === 0) && (
                      <input
                        type="text"
                        value={installateurData.nom_installateur}
                        onChange={(e) => setInstallateurData({ ...installateurData, nom_installateur: e.target.value, installateur_id: null })}
                        placeholder="Ex: Entreprise Dupont"
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition"
                        data-testid="input-nom-installateur"
                      />
                    )}
                  </div>
                </div>

                {/* Carte Montants */}
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                  <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
                    <h3 className="font-bold text-gray-900 flex items-center gap-2">
                      <Wallet className="w-5 h-5 text-green-600" />
                      Montants
                    </h3>
                  </div>
                  <div className="p-6 space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Montant du devis</label>
                      <div className="relative">
                        <input
                          type="number"
                          value={installateurData.montant_devis}
                          onChange={(e) => setInstallateurData({ ...installateurData, montant_devis: e.target.value })}
                          placeholder="0"
                          className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
                          data-testid="input-montant-devis"
                        />
                        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">€</span>
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Montant octroi ANAH</label>
                      <div className="relative">
                        <input
                          type="number"
                          value={installateurData.montant_anah}
                          onChange={(e) => setInstallateurData({ ...installateurData, montant_anah: e.target.value })}
                          placeholder="0"
                          className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                          data-testid="input-montant-anah"
                        />
                        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">€</span>
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Montant déjà payé par le client</label>
                      <div className="relative">
                        <input
                          type="number"
                          value={installateurData.montant_paye_client}
                          onChange={(e) => setInstallateurData({ ...installateurData, montant_paye_client: e.target.value })}
                          placeholder="0"
                          className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition"
                          data-testid="input-montant-paye-client"
                        />
                        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">€</span>
                      </div>
                    </div>
                    
                    {/* Résumé financier */}
                    {(installateurData.montant_devis || installateurData.montant_anah || installateurData.montant_paye_client) && (
                      <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100 space-y-3">
                        <div className="flex justify-between items-center pb-2 border-b border-blue-200">
                          <span className="text-sm text-gray-600">Reste à charge total</span>
                          <span className="text-lg font-bold text-gray-900">
                            {((parseFloat(installateurData.montant_devis) || 0) - (parseFloat(installateurData.montant_anah) || 0)).toLocaleString('fr-FR')} €
                          </span>
                        </div>
                        {installateurData.montant_paye_client && (
                          <>
                            <div className="flex justify-between items-center text-sm">
                              <span className="text-gray-600">Déjà payé par le client</span>
                              <span className="font-semibold text-purple-600">
                                - {parseFloat(installateurData.montant_paye_client).toLocaleString('fr-FR')} €
                              </span>
                            </div>
                            <div className="flex justify-between items-center pt-2 border-t border-blue-200">
                              <span className="text-sm font-medium text-gray-700">Reste à payer</span>
                              <span className={`text-xl font-bold ${
                                ((parseFloat(installateurData.montant_devis) || 0) - (parseFloat(installateurData.montant_anah) || 0) - (parseFloat(installateurData.montant_paye_client) || 0)) <= 0 
                                  ? 'text-green-600' 
                                  : 'text-orange-600'
                              }`}>
                                {((parseFloat(installateurData.montant_devis) || 0) - (parseFloat(installateurData.montant_anah) || 0) - (parseFloat(installateurData.montant_paye_client) || 0)).toLocaleString('fr-FR')} €
                              </span>
                            </div>
                            {((parseFloat(installateurData.montant_devis) || 0) - (parseFloat(installateurData.montant_anah) || 0) - (parseFloat(installateurData.montant_paye_client) || 0)) <= 0 && (
                              <div className="flex items-center gap-2 text-green-600 text-sm mt-1">
                                <Check className="w-4 h-4" />
                                <span>Entièrement payé</span>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Carte Statut Travaux */}
              <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
                  <h3 className="font-bold text-gray-900 flex items-center gap-2">
                    <Activity className="w-5 h-5 text-orange-600" />
                    Statut des travaux
                  </h3>
                </div>
                <div className="p-6">
                  <select
                    value={installateurData.statut_travaux || ''}
                    onChange={(e) => setInstallateurData({ ...installateurData, statut_travaux: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition text-lg"
                    data-testid="select-statut-travaux"
                  >
                    <option value="">— Sélectionner le statut —</option>
                    <option value="non_demarre">⏳ Non démarrés</option>
                    <option value="en_cours">🔧 En cours</option>
                    <option value="termines">✅ Terminés</option>
                  </select>
                  
                  {installateurData.statut_travaux && (
                    <div className={`mt-4 p-4 rounded-xl flex items-center gap-3 ${
                      installateurData.statut_travaux === 'termines' 
                        ? 'bg-green-50 border border-green-200' 
                        : installateurData.statut_travaux === 'en_cours'
                          ? 'bg-blue-50 border border-blue-200'
                          : 'bg-gray-50 border border-gray-200'
                    }`}>
                      <span className="text-2xl">
                        {installateurData.statut_travaux === 'termines' ? '✅' : 
                         installateurData.statut_travaux === 'en_cours' ? '🔧' : '⏳'}
                      </span>
                      <span className={`font-medium ${
                        installateurData.statut_travaux === 'termines' 
                          ? 'text-green-700' 
                          : installateurData.statut_travaux === 'en_cours'
                            ? 'text-blue-700'
                            : 'text-gray-700'
                      }`}>
                        {installateurData.statut_travaux === 'termines' ? 'Travaux terminés' : 
                         installateurData.statut_travaux === 'en_cours' ? 'Travaux en cours' : 'Travaux non démarrés'}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Carte Travaux */}
              <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
                  <h3 className="font-bold text-gray-900 flex items-center gap-2">
                    <Hammer className="w-5 h-5 text-orange-600" />
                    Types de travaux
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">Sélectionnez les travaux concernés par ce dossier</p>
                </div>
                <div className="p-6">
                  {travauxTypes.length > 0 ? (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                      {travauxTypes.map((type) => (
                        <button
                          key={type.id}
                          onClick={() => toggleTravauxSelection(type.code)}
                          className={`flex items-center gap-3 p-4 rounded-xl border-2 transition ${
                            installateurData.travaux_selectionnes.includes(type.code)
                              ? 'border-orange-500 bg-orange-50 text-orange-700'
                              : 'border-gray-200 bg-white hover:border-gray-300 text-gray-700'
                          }`}
                          data-testid={`travaux-${type.code}`}
                        >
                          <span className="text-2xl">{type.icone || '🔧'}</span>
                          <span className="font-medium">{type.nom}</span>
                          {installateurData.travaux_selectionnes.includes(type.code) && (
                            <Check className="w-5 h-5 text-orange-600 ml-auto" />
                          )}
                        </button>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      <Hammer className="w-12 h-12 mx-auto mb-2 opacity-30" />
                      <p>Aucun type de travaux configuré</p>
                      <p className="text-sm">Allez dans Widgets &gt; Travaux pour en ajouter</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Bouton Sauvegarder */}
              <div className="flex justify-end">
                <button
                  onClick={saveInstallateurData}
                  disabled={savingInstallateur}
                  className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-xl font-semibold hover:from-orange-600 hover:to-amber-600 transition shadow-lg disabled:opacity-50"
                  data-testid="save-installateur-btn"
                >
                  {savingInstallateur ? (
                    <Loader2 className="w-5 h-5 animate-spin" />
                  ) : (
                    <Save className="w-5 h-5" />
                  )}
                  Enregistrer
                </button>
              </div>
            </div>
          )}

          {/* Onglet AMO */}
          {activeTab === 'amo' && (
            <div className="space-y-6">
              {/* Header AMO */}
              <div className="bg-gradient-to-r from-teal-600 to-emerald-600 rounded-xl p-6 text-white">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                    <Building2 className="w-6 h-6" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">AMO & Demande ANAH</h2>
                    <p className="text-teal-100">Assistant à Maîtrise d'Ouvrage et suivi de la demande ANAH</p>
                  </div>
                </div>
              </div>

              {/* Contenu AMO */}
              <div className="bg-white rounded-xl border border-gray-200 p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Sélection AMO */}
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                      <Building2 className="w-5 h-5 text-teal-600" />
                      AMO du client
                    </h3>
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Sélectionner l'AMO
                        </label>
                        <select
                          value={amoData.amo_id || ''}
                          onChange={(e) => {
                            const selectedAmo = amoList.find(a => a.id === e.target.value);
                            setAmoData({
                              ...amoData,
                              amo_id: e.target.value || null,
                              amo_nom: selectedAmo?.nom || ''
                            });
                          }}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500"
                          data-testid="select-amo"
                        >
                          <option value="">— Aucun AMO sélectionné —</option>
                          {amoList.map(amo => (
                            <option key={amo.id} value={amo.id}>{amo.nom}</option>
                          ))}
                        </select>
                      </div>

                      {/* Afficher les infos de l'AMO sélectionné */}
                      {amoData.amo_id && (
                        <div className="bg-teal-50 rounded-xl p-4 border border-teal-200">
                          {(() => {
                            const selectedAmo = amoList.find(a => a.id === amoData.amo_id);
                            if (!selectedAmo) return null;
                            return (
                              <div className="space-y-2">
                                <div className="font-semibold text-teal-800">{selectedAmo.nom}</div>
                                {selectedAmo.contact && (
                                  <div className="flex items-center gap-2 text-sm text-teal-700">
                                    <User className="w-4 h-4" />
                                    {selectedAmo.contact}
                                  </div>
                                )}
                                {selectedAmo.telephone && (
                                  <div className="flex items-center gap-2 text-sm text-teal-700">
                                    <Phone className="w-4 h-4" />
                                    {selectedAmo.telephone}
                                  </div>
                                )}
                                {selectedAmo.email && (
                                  <div className="flex items-center gap-2 text-sm text-teal-700">
                                    <Mail className="w-4 h-4" />
                                    {selectedAmo.email}
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Suivi demande ANAH */}
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                      <FileText className="w-5 h-5 text-teal-600" />
                      Demande ANAH
                    </h3>
                    <div className="space-y-4">
                      {/* Demande faite ? */}
                      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                        <span className="text-sm font-medium text-gray-700">Demande effectuée auprès de l'ANAH ?</span>
                        <div className="flex items-center gap-3">
                          <label className="flex items-center gap-2 cursor-pointer">
                            <input
                              type="radio"
                              name="anah_demande"
                              checked={amoData.anah_demande_faite === true}
                              onChange={() => setAmoData({...amoData, anah_demande_faite: true})}
                              className="w-4 h-4 text-teal-600 focus:ring-teal-500"
                            />
                            <span className="text-sm">Oui</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer">
                            <input
                              type="radio"
                              name="anah_demande"
                              checked={amoData.anah_demande_faite === false}
                              onChange={() => setAmoData({...amoData, anah_demande_faite: false})}
                              className="w-4 h-4 text-teal-600 focus:ring-teal-500"
                            />
                            <span className="text-sm">Non</span>
                          </label>
                        </div>
                      </div>

                      {/* Réponse reçue ? */}
                      {amoData.anah_demande_faite && (
                        <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                          <span className="text-sm font-medium text-gray-700">Réponse reçue de l'ANAH ?</span>
                          <div className="flex items-center gap-3">
                            <label className="flex items-center gap-2 cursor-pointer">
                              <input
                                type="radio"
                                name="anah_reponse"
                                checked={amoData.anah_reponse_recue === true}
                                onChange={() => setAmoData({...amoData, anah_reponse_recue: true})}
                                className="w-4 h-4 text-teal-600 focus:ring-teal-500"
                              />
                              <span className="text-sm">Oui</span>
                            </label>
                            <label className="flex items-center gap-2 cursor-pointer">
                              <input
                                type="radio"
                                name="anah_reponse"
                                checked={amoData.anah_reponse_recue === false}
                                onChange={() => setAmoData({...amoData, anah_reponse_recue: false, anah_statut: '', anah_budget_accorde: ''})}
                                className="w-4 h-4 text-teal-600 focus:ring-teal-500"
                              />
                              <span className="text-sm">Non</span>
                            </label>
                          </div>
                        </div>
                      )}

                      {/* Statut réponse */}
                      {amoData.anah_reponse_recue && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Statut de la réponse
                          </label>
                          <select
                            value={amoData.anah_statut}
                            onChange={(e) => setAmoData({...amoData, anah_statut: e.target.value})}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500"
                          >
                            <option value="">— Sélectionner —</option>
                            <option value="valide">✅ Dossier validé</option>
                            <option value="refuse">❌ Dossier refusé</option>
                            <option value="en_attente">⏳ En attente de compléments</option>
                          </select>
                        </div>
                      )}

                      {/* Budget accordé */}
                      {amoData.anah_statut === 'valide' && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Budget accordé par l'ANAH
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              value={amoData.anah_budget_accorde}
                              onChange={(e) => setAmoData({...amoData, anah_budget_accorde: e.target.value})}
                              className="w-full px-4 py-2 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500"
                              placeholder="0"
                            />
                            <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">€</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Résumé si dossier validé */}
                {amoData.anah_statut === 'valide' && amoData.anah_budget_accorde && (
                  <div className="mt-6 p-4 bg-green-50 rounded-xl border border-green-200">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                        <CheckCircle className="w-6 h-6 text-green-600" />
                      </div>
                      <div>
                        <div className="font-semibold text-green-800">Dossier ANAH validé</div>
                        <div className="text-green-700">
                          Budget accordé : <span className="font-bold">{parseFloat(amoData.anah_budget_accorde).toLocaleString('fr-FR')} €</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Bouton enregistrer */}
                <div className="mt-6 pt-4 border-t border-gray-200">
                  <button
                    onClick={async () => {
                      setSavingAmo(true);
                      try {
                        await dossiersAPI.update(id, {
                          amo_id: amoData.amo_id,
                          amo_nom: amoData.amo_nom,
                          anah_demande_faite: amoData.anah_demande_faite,
                          anah_date_demande: amoData.anah_date_demande,
                          anah_reponse_recue: amoData.anah_reponse_recue,
                          anah_date_reponse: amoData.anah_date_reponse,
                          anah_statut: amoData.anah_statut,
                          anah_budget_accorde: amoData.anah_budget_accorde
                        });
                        loadData();
                      } catch (error) {
                        console.error('Erreur sauvegarde AMO:', error);
                        alert('Erreur lors de la sauvegarde');
                      } finally {
                        setSavingAmo(false);
                      }
                    }}
                    disabled={savingAmo}
                    className="flex items-center gap-2 px-6 py-3 bg-teal-600 text-white rounded-xl hover:bg-teal-700 transition font-medium disabled:opacity-50"
                  >
                    {savingAmo ? (
                      <Loader2 className="w-5 h-5 animate-spin" />
                    ) : (
                      <Save className="w-5 h-5" />
                    )}
                    Enregistrer
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Onglet Documents */}
          {activeTab === 'documents' && (
            <div className="space-y-4">
              {/* Barre supérieure: Complétude + Alertes */}
              {(documentsPageConfig.widget_completude !== false || documentsPageConfig.widget_alertes !== false) && (
                <div className="flex items-center justify-between flex-wrap gap-3">
                  {documentsPageConfig.widget_completude !== false && (
                    <WidgetCompletude 
                      dossierId={id}
                      refreshTrigger={widgetRefresh}
                    />
                  )}
                  {documentsPageConfig.widget_alertes !== false && (
                    <WidgetAlertes 
                      dossierId={id}
                      refreshTrigger={widgetRefresh}
                    />
                  )}
                </div>
              )}

              {/* Grille principale */}
              {(documentsPageConfig.widget_checklist !== false || documentsPageConfig.widget_formulaires !== false) && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {/* Colonne gauche - Checklist */}
                  {documentsPageConfig.widget_checklist !== false && (
                    <WidgetChecklist 
                      dossierId={id} 
                      user={user} 
                      onUpdate={() => {
                        triggerWidgetRefresh();
                        loadData();
                      }}
                    />
                  )}
                  
                  {/* Colonne droite - Formulaires */}
                  {documentsPageConfig.widget_formulaires !== false && (
                    <WidgetFormulaires 
                      dossierId={id}
                      dossier={dossier}
                      user={user}
                    />
                  )}
                </div>
              )}

              {/* Section Documents uploadés */}
              {documentsPageConfig.widget_documents_uploades !== false && documents.length > 0 && (
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200">
                    <div className="flex items-center gap-2">
                      <span className="text-lg">📁</span>
                      <h3 className="font-semibold text-gray-800">Documents uploadés</h3>
                      <span className="text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full">
                        {documents.length}
                      </span>
                    </div>
                    <button
                      onClick={() => setShowUploadModal(true)}
                      className="flex items-center gap-1 px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                      data-testid="upload-document-btn"
                    >
                      <Upload className="w-4 h-4" />
                      Ajouter
                    </button>
                  </div>
                  
                  <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                    {documents.map((doc) => (
                      <div 
                        key={doc.id} 
                        className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-sm transition"
                        data-testid={`document-${doc.id}`}
                      >
                        <div className="p-2 bg-blue-100 rounded-lg">
                          <File className="w-5 h-5 text-blue-600" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-gray-900 text-sm truncate">{doc.nom}</h4>
                          <p className="text-xs text-gray-500">{doc.type_document} • {(doc.taille / 1024).toFixed(1)} KB</p>
                        </div>
                        <div className="flex gap-1">
                          <button
                            onClick={async () => {
                              try {
                                const response = await documentsAPI.download(doc.id);
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', doc.nom);
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                              } catch (error) {
                                alert('Erreur téléchargement');
                              }
                            }}
                            className="p-1.5 text-blue-600 hover:bg-blue-50 rounded transition"
                          >
                            <Download className="w-4 h-4" />
                          </button>
                          <button
                            onClick={async () => {
                              if (window.confirm(`Supprimer "${doc.nom}" ?`)) {
                                setDeletingDocId(doc.id);
                                try {
                                  await documentsAPI.delete(doc.id, user.id, `${user.prenom} ${user.nom}`);
                                  await loadData();
                                  triggerWidgetRefresh();
                                } catch (error) {
                                  console.error('Erreur:', error);
                                } finally {
                                  setDeletingDocId(null);
                                }
                              }
                            }}
                            disabled={deletingDocId === doc.id}
                            className="p-1.5 text-red-600 hover:bg-red-50 rounded transition disabled:opacity-50"
                          >
                            {deletingDocId === doc.id ? (
                              <Loader2 className="w-4 h-4 animate-spin" />
                            ) : (
                              <Trash2 className="w-4 h-4" />
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Onglet Messagerie */}
          {activeTab === 'messagerie' && (
            <DossierMessaging 
              dossier={dossier}
              documents={documents}
              user={user}
            />
          )}
        </div>
      </div>

      {/* Modal d'upload de document */}
      {showUploadModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold text-gray-900">📤 Ajouter un document</h2>
              <button
                onClick={() => {
                  setShowUploadModal(false);
                  setSelectedDocType('');
                }}
                className="p-2 hover:bg-gray-100 rounded-lg transition"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                formData.append('dossier_id', id);
                formData.append('uploaded_by', user.id);
                formData.append('uploaded_by_nom', `${user.prenom} ${user.nom}`);

                setUploadingDoc(true);
                try {
                  await documentsAPI.upload(formData);
                  await loadData();
                  setShowUploadModal(false);
                  setSelectedDocType('');
                } catch (error) {
                  console.error('Erreur upload:', error);
                  const message = error.response?.data?.detail || 'Erreur lors de l\'upload';
                  alert(message);
                } finally {
                  setUploadingDoc(false);
                }
              }}
              className="space-y-4"
            >
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Type de document *
                </label>
                <select
                  name="type_document"
                  required
                  value={selectedDocType}
                  onChange={(e) => setSelectedDocType(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                  data-testid="select-doc-type"
                >
                  <option value="">— Sélectionner le type —</option>
                  {documentTypes.map((type) => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Fichier *
                </label>
                <input
                  type="file"
                  name="file"
                  required
                  accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100"
                  data-testid="input-file"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Formats acceptés: PDF, JPEG, PNG, WEBP, DOC, DOCX (max 10 MB)
                </p>
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowUploadModal(false);
                    setSelectedDocType('');
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-semibold"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={uploadingDoc || !selectedDocType}
                  className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-semibold disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  data-testid="submit-upload"
                >
                  {uploadingDoc ? (
                    <>
                      <Loader2 className="w-5 h-5 animate-spin" />
                      Envoi...
                    </>
                  ) : (
                    <>
                      <Upload className="w-5 h-5" />
                      Téléverser
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de modification complète */}
      {showEditModal && editFullData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            {/* Header Modal */}
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between z-10">
              <h2 className="text-xl font-bold text-gray-900">✏️ Modifier le dossier {dossier.reference}</h2>
              <button
                onClick={() => setShowEditModal(false)}
                className="p-2 hover:bg-gray-100 rounded-lg transition"
                data-testid="close-edit-modal"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="p-6 space-y-6">
              {/* Section Identité */}
              <div className="bg-blue-50 rounded-xl border border-blue-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <User className="w-5 h-5 text-blue-600" />
                  Identité du client
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
                    <input
                      type="text"
                      value={editFullData.identite.nom}
                      onChange={(e) => updateEditField('identite', 'nom', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      data-testid="edit-nom"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Prénom *</label>
                    <input
                      type="text"
                      value={editFullData.identite.prenom}
                      onChange={(e) => updateEditField('identite', 'prenom', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      data-testid="edit-prenom"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date de naissance</label>
                    <input
                      type="date"
                      value={editFullData.identite.date_naissance || ''}
                      onChange={(e) => updateEditField('identite', 'date_naissance', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div className="col-span-2 grid grid-cols-3 gap-4">
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">N° Sécurité sociale</label>
                      <input
                        type="text"
                        value={editFullData.identite.nss || ''}
                        onChange={(e) => updateEditField('identite', 'nss', e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                        placeholder="1 50 05 75 123 456 78"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Clé</label>
                      <input
                        type="text"
                        maxLength="2"
                        value={editFullData.identite.cle_nss || ''}
                        onChange={(e) => updateEditField('identite', 'cle_nss', e.target.value.replace(/\D/g, '').slice(0, 2))}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 text-center font-semibold"
                        placeholder="00"
                        data-testid="edit-cle-nss"
                      />
                    </div>
                  </div>
                  
                  {/* Bouton Recherche Caisse - Workflow DOPLI */}
                  <div className="col-span-2">
                    <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                      <label className="block text-sm font-medium text-purple-800 mb-3">
                        Caisse de retraite complémentaire
                      </label>
                      
                      <div className="flex flex-wrap items-center gap-3">
                        {/* Bouton 1 : Ouvrir DOPLI */}
                        <button
                          type="button"
                          onClick={() => {
                            const { nom, prenom, nss, cle_nss } = editFullData.identite;
                            if (!nom || !prenom || !nss || nss.length < 13 || !cle_nss || cle_nss.length !== 2) {
                              alert('Veuillez renseigner le nom, prénom, N° Sécu (13 chiffres) et la clé (2 chiffres)');
                              return;
                            }
                            // Ouvrir le site DOPLI dans un nouvel onglet
                            window.open('https://espace-personnel.agirc-arrco.fr/public/dopli', '_blank');
                            // Afficher les infos à copier
                            setTestCaisseStatus('dopli_opened');
                          }}
                          className="px-4 py-2 bg-purple-600 text-white text-sm rounded-lg hover:bg-purple-700 transition font-medium flex items-center gap-2"
                          data-testid="open-dopli-btn"
                        >
                          <ExternalLink className="w-4 h-4" />
                          Rechercher sur AGIRC-ARRCO
                        </button>
                        
                        {/* Bouton 2 : J'ai trouvé la caisse */}
                        {testCaisseStatus === 'dopli_opened' && (
                          <button
                            type="button"
                            onClick={() => setTestCaisseStatus('select_caisse')}
                            className="px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 transition font-medium flex items-center gap-2"
                            data-testid="found-caisse-btn"
                          >
                            <CheckCircle className="w-4 h-4" />
                            J'ai trouvé la caisse
                          </button>
                        )}
                        
                        {/* Affichage caisse actuelle */}
                        {editFullData.caisse && testCaisseStatus !== 'select_caisse' && (
                          <span className="text-purple-700 bg-white px-3 py-1.5 rounded-lg text-sm flex items-center gap-1 border border-purple-200">
                            <Globe className="w-4 h-4" />
                            {editFullData.caisse}
                          </span>
                        )}
                      </div>
                      
                      {/* Infos à copier quand DOPLI est ouvert */}
                      {testCaisseStatus === 'dopli_opened' && (
                        <div className="mt-3 p-3 bg-white rounded-lg border border-purple-200">
                          <p className="text-xs text-purple-600 font-medium mb-2">Informations à saisir sur DOPLI :</p>
                          <div className="grid grid-cols-2 gap-2 text-sm">
                            <div className="flex items-center justify-between bg-gray-50 px-2 py-1 rounded">
                              <span><span className="text-gray-500">Nom :</span> <span className="font-medium">{editFullData.identite.nom}</span></span>
                              <button
                                type="button"
                                onClick={() => {
                                  navigator.clipboard.writeText(editFullData.identite.nom);
                                }}
                                className="ml-2 p-1 text-gray-400 hover:text-purple-600 hover:bg-purple-100 rounded transition"
                                title="Copier"
                              >
                                <Copy className="w-3.5 h-3.5" />
                              </button>
                            </div>
                            <div className="flex items-center justify-between bg-gray-50 px-2 py-1 rounded">
                              <span><span className="text-gray-500">Prénom :</span> <span className="font-medium">{editFullData.identite.prenom}</span></span>
                              <button
                                type="button"
                                onClick={() => {
                                  navigator.clipboard.writeText(editFullData.identite.prenom);
                                }}
                                className="ml-2 p-1 text-gray-400 hover:text-purple-600 hover:bg-purple-100 rounded transition"
                                title="Copier"
                              >
                                <Copy className="w-3.5 h-3.5" />
                              </button>
                            </div>
                            <div className="flex items-center justify-between bg-gray-50 px-2 py-1 rounded">
                              <span><span className="text-gray-500">N° Sécu :</span> <span className="font-mono font-medium">{editFullData.identite.nss}</span></span>
                              <button
                                type="button"
                                onClick={() => {
                                  navigator.clipboard.writeText(editFullData.identite.nss);
                                }}
                                className="ml-2 p-1 text-gray-400 hover:text-purple-600 hover:bg-purple-100 rounded transition"
                                title="Copier"
                              >
                                <Copy className="w-3.5 h-3.5" />
                              </button>
                            </div>
                            <div className="flex items-center justify-between bg-gray-50 px-2 py-1 rounded">
                              <span><span className="text-gray-500">Clé :</span> <span className="font-mono font-medium">{editFullData.identite.cle_nss}</span></span>
                              <button
                                type="button"
                                onClick={() => {
                                  navigator.clipboard.writeText(editFullData.identite.cle_nss);
                                }}
                                className="ml-2 p-1 text-gray-400 hover:text-purple-600 hover:bg-purple-100 rounded transition"
                                title="Copier"
                              >
                                <Copy className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      
                      {/* Dropdown de sélection de caisse */}
                      {testCaisseStatus === 'select_caisse' && (
                        <div className="mt-3 p-3 bg-white rounded-lg border border-green-200">
                          <label className="block text-sm font-medium text-green-800 mb-2">
                            Sélectionnez la caisse trouvée :
                          </label>
                          <select
                            value={editFullData.caisse || ''}
                            onChange={(e) => {
                              setEditFullData(prev => ({ ...prev, caisse: e.target.value }));
                              if (e.target.value) {
                                setTestCaisseStatus('valid');
                                setTestCaisseResult(e.target.value);
                              }
                            }}
                            className="w-full px-4 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 bg-white"
                            data-testid="select-caisse-dropdown"
                          >
                            <option value="">— Sélectionner la caisse —</option>
                            {caisses.map(c => (
                              <option key={c.id} value={c.nom}>{c.nom}</option>
                            ))}
                            <option value="__non_affilie__">❌ Non affilié / Pas de caisse</option>
                          </select>
                          <div className="flex gap-2 mt-2">
                            <button
                              type="button"
                              onClick={() => setTestCaisseStatus('dopli_opened')}
                              className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800"
                            >
                              ← Retour
                            </button>
                          </div>
                        </div>
                      )}
                      
                      {/* Résultat validé */}
                      {testCaisseStatus === 'valid' && testCaisseResult && (
                        <div className="mt-3 flex items-center gap-2">
                          <span className="text-green-700 font-medium flex items-center gap-2 bg-green-100 px-3 py-1.5 rounded-lg">
                            <CheckCircle className="w-4 h-4" />
                            {testCaisseResult === '__non_affilie__' ? 'Non affilié' : `Caisse enregistrée : ${testCaisseResult}`}
                          </span>
                          <button
                            type="button"
                            onClick={() => {
                              setTestCaisseStatus(null);
                              setTestCaisseResult(null);
                            }}
                            className="text-sm text-gray-500 hover:text-gray-700"
                          >
                            Modifier
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Adresse *</label>
                    <input
                      type="text"
                      value={editFullData.identite.adresse}
                      onChange={(e) => updateEditField('identite', 'adresse', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Code postal *</label>
                    <input
                      type="text"
                      value={editFullData.identite.code_postal}
                      onChange={(e) => updateEditField('identite', 'code_postal', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Ville *</label>
                    <input
                      type="text"
                      value={editFullData.identite.ville}
                      onChange={(e) => updateEditField('identite', 'ville', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone *</label>
                    <input
                      type="tel"
                      value={editFullData.identite.telephone}
                      onChange={(e) => updateEditField('identite', 'telephone', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      value={editFullData.identite.email || ''}
                      onChange={(e) => updateEditField('identite', 'email', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                </div>
              </div>

              {/* Section Situation */}
              <div className="bg-purple-50 rounded-xl border border-purple-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <Home className="w-5 h-5 text-purple-600" />
                  Situation
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Type de logement</label>
                    <select
                      value={editFullData.situation.type_logement || ''}
                      onChange={(e) => updateEditField('situation', 'type_logement', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      <option value="">— Sélectionner —</option>
                      <option value="Appartement">Appartement</option>
                      <option value="Maison">Maison</option>
                      <option value="Foyer">Foyer</option>
                      <option value="Autre">Autre</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Situation familiale</label>
                    <select
                      value={editFullData.situation.situation_familiale || ''}
                      onChange={(e) => updateEditField('situation', 'situation_familiale', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      <option value="">— Sélectionner —</option>
                      <option value="Célibataire">Célibataire</option>
                      <option value="Marié(e)">Marié(e)</option>
                      <option value="Pacsé(e)">Pacsé(e)</option>
                      <option value="Veuf(ve)">Veuf(ve)</option>
                      <option value="Divorcé(e)">Divorcé(e)</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Situation pro demandeur</label>
                    <select
                      value={editFullData.situation.situation_pro_demandeur || ''}
                      onChange={(e) => updateEditField('situation', 'situation_pro_demandeur', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      <option value="">— Sélectionner —</option>
                      <option value="Retraité(e)">Retraité(e)</option>
                      <option value="Actif(ve)">Actif(ve)</option>
                      <option value="Sans emploi">Sans emploi</option>
                      <option value="Invalidité">Invalidité</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Situation pro conjoint</label>
                    <select
                      value={editFullData.situation.situation_pro_conjoint || ''}
                      onChange={(e) => updateEditField('situation', 'situation_pro_conjoint', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      <option value="">— Sélectionner —</option>
                      <option value="Retraité(e)">Retraité(e)</option>
                      <option value="Actif(ve)">Actif(ve)</option>
                      <option value="Sans emploi">Sans emploi</option>
                      <option value="Invalidité">Invalidité</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Section Ressources */}
              <div className="bg-green-50 rounded-xl border border-green-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <Wallet className="w-5 h-5 text-green-600" />
                  Ressources mensuelles
                </h3>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Retraite de base (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.ressources.retraite_base}
                      onChange={(e) => updateEditField('ressources', 'retraite_base', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      data-testid="edit-retraite-base"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Retraite complémentaire (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.ressources.retraite_complementaire}
                      onChange={(e) => updateEditField('ressources', 'retraite_complementaire', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Autres revenus (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.ressources.autres_revenus}
                      onChange={(e) => updateEditField('ressources', 'autres_revenus', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div className="col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Détail autres revenus</label>
                    <input
                      type="text"
                      value={editFullData.ressources.autres_revenus_detail || ''}
                      onChange={(e) => updateEditField('ressources', 'autres_revenus_detail', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      placeholder="Ex: Pension de réversion, APL..."
                    />
                  </div>
                </div>
              </div>

              {/* Section Charges */}
              <div className="bg-red-50 rounded-xl border border-red-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <CreditCard className="w-5 h-5 text-red-600" />
                  Charges mensuelles
                </h3>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Loyer (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.loyer}
                      onChange={(e) => updateEditField('charges', 'loyer', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      data-testid="edit-loyer"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Copropriété (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.copropriete}
                      onChange={(e) => updateEditField('charges', 'copropriete', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Taxe foncière (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.taxe_fonciere}
                      onChange={(e) => updateEditField('charges', 'taxe_fonciere', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Impôt sur revenu (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.impot_revenu}
                      onChange={(e) => updateEditField('charges', 'impot_revenu', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Énergie (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.energie}
                      onChange={(e) => updateEditField('charges', 'energie', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Eau (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.eau}
                      onChange={(e) => updateEditField('charges', 'eau', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Téléphonie (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.telephonie}
                      onChange={(e) => updateEditField('charges', 'telephonie', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Assurance habitation (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.assurance_habitation}
                      onChange={(e) => updateEditField('charges', 'assurance_habitation', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Assurance véhicule (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.assurance_vehicule}
                      onChange={(e) => updateEditField('charges', 'assurance_vehicule', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Autres assurances (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.assurance_autre}
                      onChange={(e) => updateEditField('charges', 'assurance_autre', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Autres charges (€)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={editFullData.charges.autres_charges}
                      onChange={(e) => updateEditField('charges', 'autres_charges', parseFloat(e.target.value) || 0)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Détail autres charges</label>
                    <input
                      type="text"
                      value={editFullData.charges.autres_charges_detail || ''}
                      onChange={(e) => updateEditField('charges', 'autres_charges_detail', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                </div>
              </div>

              {/* Section Dossier */}
              <div className="bg-yellow-50 rounded-xl border border-yellow-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <FileText className="w-5 h-5 text-yellow-600" />
                  Informations du dossier
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Caisse de retraite *</label>
                    <select
                      value={editFullData.caisse}
                      onChange={(e) => updateEditField(null, 'caisse', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      {caisses.map(c => (
                        <option key={c.id} value={c.nom}>{c.nom}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Source</label>
                    <select
                      value={editFullData.source}
                      onChange={(e) => updateEditField(null, 'source', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      <option value="conseiller">Conseiller</option>
                      <option value="telephone">Téléphone</option>
                      <option value="courrier">Courrier</option>
                      <option value="lien">Lien/Web</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Statut</label>
                    <select
                      value={editFullData.statut}
                      onChange={(e) => updateEditField(null, 'statut', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      {statuts.map(s => (
                        <option key={s.code} value={s.code}>{s.icone} {s.label}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Priorité</label>
                    <select
                      value={editFullData.priorite}
                      onChange={(e) => updateEditField(null, 'priorite', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      <option value="low">🟢 Basse</option>
                      <option value="med">🟠 Moyenne</option>
                      <option value="high">🔴 Haute</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Gestionnaire</label>
                    <select
                      value={editFullData.gestionnaire_id}
                      onChange={(e) => updateEditField(null, 'gestionnaire_id', e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    >
                      <option value="">— Non assigné —</option>
                      {gestionnaires.map(g => (
                        <option key={g.id} value={g.id}>{g.prenom} {g.nom}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Motif de la demande *</label>
                    <textarea
                      value={editFullData.motif}
                      onChange={(e) => updateEditField(null, 'motif', e.target.value)}
                      rows="3"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Note interne</label>
                    <textarea
                      value={editFullData.note_interne}
                      onChange={(e) => updateEditField(null, 'note_interne', e.target.value)}
                      rows="2"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      placeholder="Notes internes pour les gestionnaires..."
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Modal */}
            <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex items-center justify-between">
              <button
                onClick={() => setShowEditModal(false)}
                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 font-semibold hover:bg-gray-50 transition"
              >
                Annuler
              </button>
              <button
                onClick={handleFullSave}
                disabled={saving}
                className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition flex items-center gap-2 disabled:opacity-50"
                data-testid="save-edit-modal"
              >
                {saving ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    Enregistrement...
                  </>
                ) : (
                  <>
                    <Save className="w-5 h-5" />
                    Enregistrer les modifications
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Barre d'outils discrète en bas */}
      <div className="bg-gradient-to-r from-slate-50 to-pink-50 rounded-xl border border-pink-100 p-3">
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-400">Outils</span>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setShowAI(!showAI)}
              className="px-3 py-1.5 bg-white border border-gray-200 text-gray-600 rounded-lg text-xs font-medium hover:bg-gradient-to-r hover:from-purple-500 hover:to-violet-500 hover:text-white hover:border-transparent transition flex items-center gap-1.5 shadow-sm"
            >
              <MessageSquare className="w-3.5 h-3.5" />
              Assistant IA
            </button>
            <button
              onClick={handleExportPDF}
              className="px-3 py-1.5 bg-white border border-gray-200 text-gray-600 rounded-lg text-xs font-medium hover:bg-gradient-to-r hover:from-blue-500 hover:to-cyan-500 hover:text-white hover:border-transparent transition flex items-center gap-1.5 shadow-sm"
            >
              <Download className="w-3.5 h-3.5" />
              Export PDF
            </button>
          </div>
        </div>
      </div>

      {/* Modal Lien Client */}
      {showClientLinkModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <Check className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">
                    {clientLinkConfig.modal_title || 'Lien de complétion client'}
                  </h3>
                  <p className="text-green-100 text-sm">Dossier {dossier?.reference}</p>
                </div>
              </div>
            </div>
            
            {/* Content */}
            <div className="p-6">
              <p className="text-gray-600 mb-4">
                {clientLinkConfig.modal_message || 'Envoyez ce lien au client pour qu\'il complète ses informations.'}
              </p>
              
              {/* Lien */}
              <div className="bg-gray-100 rounded-xl p-4 mb-4">
                <label className="block text-xs text-gray-500 mb-2">Lien à partager :</label>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={clientLink || ''}
                    readOnly
                    className="flex-1 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono text-gray-700"
                    onClick={(e) => e.target.select()}
                  />
                </div>
              </div>

              {/* Message de succès */}
              {copySuccess && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4 flex items-center gap-2 text-green-700">
                  <Check className="w-5 h-5" />
                  <span className="font-medium">{clientLinkConfig.success_message || 'Lien copié avec succès !'}</span>
                </div>
              )}

              {/* Info */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm text-blue-800">
                <p>💡 Le client pourra compléter les informations manquantes sans avoir besoin de se connecter.</p>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 bg-gray-50 flex gap-3">
              <button
                onClick={handleCopyClientLink}
                className={`flex-1 px-4 py-3 rounded-xl font-semibold transition flex items-center justify-center gap-2 ${
                  copySuccess
                    ? 'bg-green-100 text-green-700 border-2 border-green-300'
                    : 'bg-green-600 text-white hover:bg-green-700'
                }`}
                data-testid="modal-copy-link-btn"
              >
                {copySuccess ? (
                  <>
                    <Check className="w-5 h-5" />
                    Copié !
                  </>
                ) : (
                  <>
                    <Copy className="w-5 h-5" />
                    Copier le lien
                  </>
                )}
              </button>
              <button
                onClick={() => {
                  setShowClientLinkModal(false);
                  setCopySuccess(false);
                }}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-100 transition"
                data-testid="modal-close-btn"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal lien documents */}
      {showDocumentsLinkModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-purple-500 to-violet-600 px-6 py-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <Upload className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">
                    Lien d'envoi de documents
                  </h3>
                  <p className="text-purple-100 text-sm">Dossier {dossier?.reference}</p>
                </div>
              </div>
            </div>
            
            {/* Content */}
            <div className="p-6">
              <p className="text-gray-600 mb-4">
                Envoyez ce lien au client pour qu'il puisse téléverser les documents manquants.
              </p>
              
              {/* Lien */}
              <div className="bg-gray-100 rounded-xl p-4 mb-4">
                <label className="block text-xs text-gray-500 mb-2">Lien à partager :</label>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={documentsLink || ''}
                    readOnly
                    className="flex-1 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono text-gray-700"
                    onClick={(e) => e.target.select()}
                  />
                </div>
              </div>

              {/* Message de succès */}
              {copyDocumentsSuccess && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4 flex items-center gap-2 text-green-700">
                  <Check className="w-5 h-5" />
                  <span className="font-medium">Lien copié avec succès !</span>
                </div>
              )}

              {/* Info */}
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 text-sm text-purple-800">
                <p>📄 Le client verra la liste des documents manquants et pourra les téléverser directement.</p>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 bg-gray-50 flex gap-3">
              <button
                onClick={handleCopyDocumentsLink}
                className={`flex-1 px-4 py-3 rounded-xl font-semibold transition flex items-center justify-center gap-2 ${
                  copyDocumentsSuccess
                    ? 'bg-green-100 text-green-700 border-2 border-green-300'
                    : 'bg-purple-600 text-white hover:bg-purple-700'
                }`}
                data-testid="modal-copy-documents-link-btn"
              >
                {copyDocumentsSuccess ? (
                  <>
                    <Check className="w-5 h-5" />
                    Copié !
                  </>
                ) : (
                  <>
                    <Copy className="w-5 h-5" />
                    Copier le lien
                  </>
                )}
              </button>
              <button
                onClick={() => {
                  setShowDocumentsLinkModal(false);
                  setCopyDocumentsSuccess(false);
                }}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-100 transition"
                data-testid="modal-close-documents-btn"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal action rapide */}
      {showQuickActionModal && quickActionType && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
            {/* Header */}
            <div className={`${quickActionTypes[quickActionType].color} px-6 py-4`}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center text-2xl">
                  {quickActionTypes[quickActionType].icon}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">
                    {quickActionTypes[quickActionType].label}
                  </h3>
                  <p className="text-white/80 text-sm">Dossier {dossier?.reference}</p>
                </div>
              </div>
            </div>
            
            {/* Content */}
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Date et heure
                </label>
                <input
                  type="datetime-local"
                  value={quickActionDate}
                  onChange={(e) => setQuickActionDate(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Note / Détails
                </label>
                <textarea
                  value={quickActionNote}
                  onChange={(e) => setQuickActionNote(e.target.value)}
                  placeholder={quickActionTypes[quickActionType].description}
                  rows="3"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                  autoFocus
                />
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 bg-gray-50 flex gap-3">
              <button
                onClick={handleSaveQuickAction}
                disabled={!quickActionNote.trim() || savingQuickAction}
                className={`flex-1 px-4 py-3 rounded-xl font-semibold transition flex items-center justify-center gap-2 ${quickActionTypes[quickActionType].color} text-white hover:opacity-90 disabled:opacity-50`}
              >
                {savingQuickAction ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Enregistrement...
                  </>
                ) : (
                  <>
                    <Check className="w-5 h-5" />
                    Enregistrer
                  </>
                )}
              </button>
              <button
                onClick={() => setShowQuickActionModal(false)}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-100 transition"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DossierDetail;
